<template>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   version="1.1"
   x="0px"
   y="0px"
   width="622.29999"
   height="301.60001"
   viewBox="0 0 622.29997 301.60001"
   xml:space="preserve"
   id="svg714"
   sodipodi:docname="pantalla 7-11.svg"
   inkscape:version="0.92.4 (5da689c313, 2019-01-14)"><metadata
   id="metadata720"><rdf:RDF><cc:Work
       rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type
         rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs
   id="defs718" /><sodipodi:namedview
   pagecolor="#ffffff"
   bordercolor="#666666"
   borderopacity="1"
   objecttolerance="10"
   gridtolerance="10"
   guidetolerance="10"
   inkscape:pageopacity="0"
   inkscape:pageshadow="2"
   inkscape:window-width="1920"
   inkscape:window-height="1017"
   id="namedview716"
   showgrid="false"
   inkscape:zoom="0.52175211"
   inkscape:cx="311.05001"
   inkscape:cy="157.95"
   inkscape:window-x="-8"
   inkscape:window-y="-8"
   inkscape:window-maximized="1"
   inkscape:current-layer="pantalla_7" />
<g
   id="Capa_2"
   transform="translate(-23.400002,-25.299999)">
</g>
<g
   id="pantalla_1"
   transform="translate(-23.400002,-25.299999)">
</g>
<g
   id="pantalla_2"
   transform="translate(-23.400002,-25.299999)">
</g>
<g
   id="pantalla__3"
   transform="translate(-23.400002,-25.299999)">
</g>
<g
   id="pantalla_4"
   transform="translate(-23.400002,-25.299999)">
</g>
<g
   id="pantalla_5"
   transform="translate(-23.400002,-25.299999)">
</g>
<g
   id="pantalla_7"
   transform="translate(-23.400002,-25.299999)">
	<linearGradient
   id="XMLID_384_"
   gradientUnits="userSpaceOnUse"
   x1="79.080101"
   y1="171.39059"
   x2="589.22272"
   y2="171.39059">
		<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop10" />
		<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop12" />
	</linearGradient>
	<path
   id="XMLID_6109_"
   style="fill:none;stroke:url(#XMLID_384_);stroke-width:5;stroke-miterlimit:10"
   d="M 586.7,252.9 V 133.5 c 0,0 1.8,-51.7 -41.1,-53.6 0,0 -43.1,-3.9 -43.1,53.6 v 73.2 c 0,57.5 -43.1,53.6 -43.1,53.6 -42.9,-1.9 -41.1,-53.6 -41.1,-53.6 v -65.3 c 0,0 1.8,-51.7 -41.1,-53.6 0,0 -43.1,-3.9 -43.1,53.6 v 73.2 c 0,50.5 -43.1,48.2 -43.1,48.2 -42.9,-1.9 -41.1,-48.2 -41.1,-48.2 V 136 c 0,0 1.8,-51.7 -41.1,-53.6 0,0 -43.1,-3.9 -43.1,53.6 v 73.2 c 0,57.5 -43.1,53.6 -43.1,53.6 C 79.7,260.9 81.5,209.2 81.5,209.2 V 82.4"
   inkscape:connector-curvature="0" />
	<g
   id="img2"
   :class="[{'': vistos[1]} ]" @click="darVisto(1)"
   inkscape:label="#XMLID_7047_">
		<linearGradient
   id="XMLID_387_"
   gradientUnits="userSpaceOnUse"
   x1="64.510696"
   y1="257.31149"
   x2="181.6748"
   y2="257.31149">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop16" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop18" />
		</linearGradient>
		
			<circle
   id="XMLID_7127_"
   style="fill:#ffffff;stroke:url(#XMLID_387_);stroke-width:3;stroke-miterlimit:10"
   cx="123.1"
   cy="257.29999"
   r="57.099998" />
		<g
   id="XMLID_7051_">
			<g
   id="XMLID_7087_">
				<linearGradient
   id="XMLID_392_"
   gradientUnits="userSpaceOnUse"
   x1="101.9209"
   y1="252.0459"
   x2="144.2666"
   y2="252.0459">
					<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop22" />
					<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop24" />
				</linearGradient>
				<ellipse
   id="XMLID_7121_"
   class="st880"
   cx="123.1"
   cy="252"
   rx="21.200001"
   ry="21.4"
   style="fill:url(#XMLID_392_)" />
				<ellipse
   id="XMLID_7095_"
   class="st866"
   cx="123.1"
   cy="252"
   rx="10.1"
   ry="11"
   style="fill:#042ab2" />
				<ellipse
   id="XMLID_7091_"
   class="st736"
   cx="131.10001"
   cy="242.39999"
   rx="6.8000002"
   ry="6.5999999"
   style="fill:#ffffff" />
			</g>
			<path
   id="XMLID_7082_"
   class="st866"
   d="m 123.1,292 c -22,0 -39.9,-17.9 -39.9,-39.9 0,-22 17.9,-39.9 39.9,-39.9 22,0 39.9,17.8 39.9,39.8 0,22.1 -17.9,40 -39.9,40 z m 0,-73.6 c -18.6,0 -33.7,15.1 -33.7,33.7 0,18.6 15.1,33.7 33.7,33.7 18.6,0 33.7,-15.1 33.7,-33.7 -0.1,-18.6 -15.2,-33.7 -33.7,-33.7 z"
   inkscape:connector-curvature="0"
   style="fill:#042ab2" />
			<rect
   id="XMLID_7078_"
   x="118.8"
   y="288.79999"
   class="st866"
   width="8.6000004"
   height="25.5"
   style="fill:#042ab2" />
			<rect
   id="XMLID_7052_"
   x="115.2"
   y="297"
   class="st525"
   width="15.8"
   height="17.4"
   style="fill:#2368d9" />
		</g>
		<linearGradient
   id="XMLID_396_"
   gradientUnits="userSpaceOnUse"
   x1="64.510696"
   y1="257.31149"
   x2="181.6748"
   y2="257.31149">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop35" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop37" />
		</linearGradient>
		
			<circle
   id="XMLID_7048_"
   style="fill:none;stroke:url(#XMLID_396_);stroke-width:3;stroke-miterlimit:10"
   cx="123.1"
   cy="257.29999"
   r="57.099998" />
	</g>
	<g
   id="img4"
   :class="[{'': vistos[3]} ]" @click="darVisto(3)"
   inkscape:label="#XMLID_6107_">
		<linearGradient
   id="XMLID_397_"
   gradientUnits="userSpaceOnUse"
   x1="234.1465"
   y1="257.31149"
   x2="351.31049"
   y2="257.31149">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop42" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop44" />
		</linearGradient>
		
			<circle
   id="XMLID_2351_"
   style="fill:#ffffff;stroke:url(#XMLID_397_);stroke-width:3;stroke-miterlimit:10"
   cx="292.70001"
   cy="257.29999"
   r="57.099998" />
		<g
   id="XMLID_6543_">
			<rect
   id="XMLID_6716_"
   x="256.70001"
   y="226"
   class="st722"
   width="72"
   height="67"
   style="fill:#ff9852" />
			<rect
   id="XMLID_6713_"
   x="259.70001"
   y="228.7"
   class="st736"
   width="66.300003"
   height="60.900002"
   style="fill:#ffffff" />
			<linearGradient
   id="XMLID_398_"
   gradientUnits="userSpaceOnUse"
   x1="265.51459"
   y1="242.82809"
   x2="321.043"
   y2="242.82809">
				<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop50" />
				<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop52" />
			</linearGradient>
			<rect
   id="XMLID_6712_"
   x="265.5"
   y="238"
   class="st882"
   width="55.5"
   height="9.6999998"
   style="fill:url(#XMLID_398_)" />
			<rect
   id="XMLID_6709_"
   x="317.70001"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_6706_"
   x="304.60001"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_6703_"
   x="291.60001"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_6700_"
   x="278.60001"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_6697_"
   x="265.5"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<g
   id="XMLID_6681_">
				<rect
   id="XMLID_6694_"
   x="265.5"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6691_"
   x="276.79999"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6688_"
   x="288.20001"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6685_"
   x="299.5"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6682_"
   x="310.79999"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_6661_">
				<rect
   id="XMLID_6678_"
   x="265.5"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6675_"
   x="276.79999"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6672_"
   x="288.20001"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6669_"
   x="299.5"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6663_"
   x="310.79999"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_6616_">
				<rect
   id="XMLID_6658_"
   x="265.5"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6655_"
   x="276.79999"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6651_"
   x="288.20001"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6623_"
   x="299.5"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_6617_"
   x="310.79999"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_6610_">
				<linearGradient
   id="XMLID_400_"
   gradientUnits="userSpaceOnUse"
   x1="278.39059"
   y1="255.3613"
   x2="285.1055"
   y2="255.3613">
					<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop79" />
					<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop81" />
				</linearGradient>
				<path
   id="XMLID_6612_"
   class="st884"
   d="m 279,258.7 c -0.1,0 -0.3,-0.1 -0.4,-0.2 -0.2,-0.2 -0.2,-0.6 0,-0.8 l 5.6,-5.6 c 0.2,-0.2 0.6,-0.2 0.8,0 0.2,0.2 0.2,0.6 0,0.8 l -5.6,5.6 c -0.1,0.2 -0.3,0.2 -0.4,0.2 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_400_)" />
				
					<linearGradient
   id="XMLID_411_"
   gradientUnits="userSpaceOnUse"
   x1="-346.11331"
   y1="255.3613"
   x2="-339.39841"
   y2="255.3613"
   gradientTransform="matrix(-1,0,0,1,-61.0078,0)">
					<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop85" />
					<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop87" />
				</linearGradient>
				<path
   id="XMLID_6611_"
   style="fill:url(#XMLID_411_)"
   d="m 284.5,258.7 c -0.1,0 -0.3,-0.1 -0.4,-0.2 l -5.6,-5.6 c -0.2,-0.2 -0.2,-0.6 0,-0.8 0.2,-0.2 0.6,-0.2 0.8,0 l 5.6,5.6 c 0.2,0.2 0.2,0.6 0,0.8 -0.1,0.2 -0.2,0.2 -0.4,0.2 z"
   inkscape:connector-curvature="0" />
			</g>
		</g>
	</g>
	<g
   id="img8"
   :class="[{'': vistos[7]} ]" @click="darVisto(7)"
   inkscape:label="#XMLID_7387_">
		<linearGradient
   id="XMLID_465_"
   gradientUnits="userSpaceOnUse"
   x1="528.53998"
   y1="257.31149"
   x2="645.7041"
   y2="257.31149">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop94" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop96" />
		</linearGradient>
		
			<circle
   id="XMLID_2368_"
   style="fill:#ffffff;stroke:url(#XMLID_465_);stroke-width:3;stroke-miterlimit:10"
   cx="587.09998"
   cy="257.29999"
   r="57.099998" />
		<g
   id="XMLID_5701_">
			<rect
   id="XMLID_7334_"
   x="551.5"
   y="226"
   class="st722"
   width="72"
   height="67"
   style="fill:#ff9852" />
			<rect
   id="XMLID_7331_"
   x="554.5"
   y="228.7"
   class="st736"
   width="66.300003"
   height="60.900002"
   style="fill:#ffffff" />
			<linearGradient
   id="XMLID_4266_"
   gradientUnits="userSpaceOnUse"
   x1="560.30658"
   y1="242.82809"
   x2="615.83398"
   y2="242.82809">
				<stop
   offset="0"
   style="stop-color:#F9385D"
   id="stop102" />
				<stop
   offset="1"
   style="stop-color:#C0255B"
   id="stop104" />
			</linearGradient>
			<rect
   id="XMLID_7330_"
   x="560.29999"
   y="238"
   class="st318"
   width="55.5"
   height="9.6999998"
   style="fill:url(#XMLID_4266_)" />
			<rect
   id="XMLID_7327_"
   x="612.5"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_7324_"
   x="599.40002"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_7321_"
   x="586.40002"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_7318_"
   x="573.29999"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<rect
   id="XMLID_7315_"
   x="560.29999"
   y="219"
   class="st855"
   width="3.4000001"
   height="14.4"
   style="fill:#d1d1d1" />
			<g
   id="XMLID_7299_">
				<rect
   id="XMLID_7312_"
   x="560.29999"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7309_"
   x="571.59998"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7306_"
   x="583"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7303_"
   x="594.29999"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7300_"
   x="605.59998"
   y="250.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_7283_">
				<rect
   id="XMLID_7296_"
   x="560.29999"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7293_"
   x="571.59998"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7290_"
   x="583"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7287_"
   x="594.29999"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7284_"
   x="605.59998"
   y="262.5"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<g
   id="XMLID_7260_">
				<rect
   id="XMLID_7280_"
   x="560.29999"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7277_"
   x="571.59998"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7274_"
   x="583"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7270_"
   x="594.29999"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
				<rect
   id="XMLID_7261_"
   x="605.59998"
   y="274.60001"
   class="st883"
   width="9.8000002"
   height="9.8000002"
   style="fill:#d6d6d6" />
			</g>
			<path
   id="XMLID_5690_"
   class="st315"
   d="m 565.2,272.2 c -0.4,0 -0.8,-0.2 -1,-0.5 l -3.2,-4.1 c -0.4,-0.6 -0.4,-1.4 0.2,-1.8 0.6,-0.4 1.4,-0.3 1.8,0.2 l 2.1,2.7 3.9,-5.9 c 0.4,-0.6 1.2,-0.8 1.8,-0.4 0.6,0.4 0.8,1.2 0.4,1.8 l -4.9,7.3 c -0.2,0.4 -0.6,0.6 -1.1,0.7 0.1,0 0,0 0,0 z"
   inkscape:connector-curvature="0"
   style="fill:#4d8e02" />
		</g>
	</g>
	<g
   id="img1"
   :class="[{'': vistos[0]} ]" @click="darVisto(0)"
   inkscape:label="#XMLID_2393_">
		<linearGradient
   id="XMLID_4267_"
   gradientUnits="userSpaceOnUse"
   x1="23.4063"
   y1="95.8936"
   x2="140.5703"
   y2="95.8936">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop134" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop136" />
		</linearGradient>
		
			<circle
   id="XMLID_6114_"
   style="fill:#ffffff;stroke:url(#XMLID_4267_);stroke-width:3;stroke-miterlimit:10"
   cx="82"
   cy="95.900002"
   r="57.099998" />
		<g
   id="XMLID_6721_">
			<defs
   id="defs141">
				<circle
   id="XMLID_6722_"
   cx="82"
   cy="95.900002"
   r="57.200001" />
			</defs>
			<clipPath
   id="XMLID_4274_">
				<use
   xlink:href="#XMLID_6722_"
   style="overflow:visible"
   id="use143"
   x="0"
   y="0"
   width="100%"
   height="100%" />
			</clipPath>
			<g
   id="XMLID_6723_"
   clip-path="url(#XMLID_4274_)">
				
					<linearGradient
   id="XMLID_4278_"
   gradientUnits="userSpaceOnUse"
   x1="64.115196"
   y1="-17199.676"
   x2="64.115196"
   y2="-17329.135"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop146" />
					<stop
   offset="1"
   style="stop-color:#707070"
   id="stop148" />
				</linearGradient>
				<path
   id="XMLID_6844_"
   style="fill:url(#XMLID_4278_)"
   d="M 67.4,163.7 57,160.2 c 0,0 -4.3,-4.4 -0.7,-14.7 0,0 1.8,-6.1 1.5,-11.5 0,0 2.7,-2.1 0.1,-5.6 0,0 1.2,-11.2 -5.4,-21.7 0,0 -3.7,-10.4 0.8,-42.1 0,0 0.2,-5.9 7.5,-7.7 0,0 14.2,-5.3 16.5,-1.4 -0.1,-0.1 -1.1,103.8 -9.9,108.2 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_4280_"
   gradientUnits="userSpaceOnUse"
   x1="61.712898"
   y1="-17260.465"
   x2="112.1338"
   y2="-17260.465"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop152" />
					<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop154" />
				</linearGradient>
				<path
   id="XMLID_6843_"
   class="st321"
   d="m 65.6,67.7 -3.7,32.5 c 0,0 -1.5,9.1 3.7,14.2 0,0 7.1,11.4 0.9,35.7 0,0 -4.5,15.1 3.6,13.9 l 36.3,-6.9 c 0,0 6.5,-1.4 1.4,-14.2 0,0 -4.6,-21.2 3,-38.6 0,0 3.4,-1.2 -0.9,-39.9 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4280_)" />
				
					<linearGradient
   id="XMLID_4304_"
   gradientUnits="userSpaceOnUse"
   x1="88.381798"
   y1="-17206.148"
   x2="88.381798"
   y2="-17309.381"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop158" />
					<stop
   offset="1"
   style="stop-color:#707070"
   id="stop160" />
				</linearGradient>
				<path
   id="XMLID_6842_"
   class="st325"
   d="m 70.6,66 -2.3,35 c 0,0 -1.2,5.8 1.1,10.4 0,0 5.4,25.5 1.1,40 0,0 -3,10.9 0.7,10.3 l 33.7,-6.8 c 0,0 3.2,-1.9 0,-9 0,0 -4,-25.4 1.4,-38.3 0,0 3.2,-3.8 2.2,-12.5 L 106.2,63.4 C 106.3,63.5 84,58.8 70.6,66 Z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4304_)" />
				
					<linearGradient
   id="XMLID_4307_"
   gradientUnits="userSpaceOnUse"
   x1="62.213902"
   y1="-17304.91"
   x2="62.213902"
   y2="-17205.912"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop164" />
					<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop166" />
				</linearGradient>
				<path
   id="XMLID_6841_"
   class="st326"
   d="m 58.6,160.7 c 0,0 -3.2,-5.2 0,-14.8 0,0 5.5,-19.8 -4,-39 0,0 -1.1,-18 2.8,-42.4 0,0 -0.5,-4.9 13.5,-7.7 l -0.3,-0.5 c 0,0 -13.7,2.2 -14.1,8.1 0,0 -3.1,17.9 -2.9,42.2 l 0.6,1.5 c 0,0 9.8,18.4 2.7,40.3 0,0 -2.3,7 0.8,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4307_)" />
				
					<linearGradient
   id="XMLID_4312_"
   gradientUnits="userSpaceOnUse"
   x1="90.502899"
   y1="-17207.227"
   x2="90.502899"
   y2="-17307.082"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop170" />
					<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop172" />
				</linearGradient>
				<path
   id="XMLID_6840_"
   style="fill:url(#XMLID_4312_)"
   d="m 72.7,66 -2.3,35 c 0,0 -1.2,5.8 1.1,10.4 0,0 5.4,25.5 1.1,40 0,0 -3.1,10.4 0.6,9.9 l 33.7,-6.3 c 0,0 3.2,-1.9 0,-9 0,0 -4,-25.4 1.4,-38.3 0,0 3.2,-3.8 2.2,-12.5 l -2.3,-31.7 c 0.2,0 -22.1,-4.7 -35.5,2.5 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_4315_"
   gradientUnits="userSpaceOnUse"
   x1="100.6553"
   y1="-17207.043"
   x2="109.9727"
   y2="-17207.043"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#B2B8D1"
   id="stop176" />
					<stop
   offset="1"
   style="stop-color:#545D70"
   id="stop178" />
				</linearGradient>
				<path
   id="XMLID_6839_"
   style="fill:url(#XMLID_4315_);stroke:#383838;stroke-miterlimit:10"
   d="m 100.7,56.8 c 0,0 8,0.6 8.8,4.2 l 0.5,3.5 -7.2,0.5 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_4317_"
   gradientUnits="userSpaceOnUse"
   x1="89.961899"
   y1="-17301.547"
   x2="89.961899"
   y2="-17279.348"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop182" />
					<stop
   offset="1"
   style="stop-color:#272A2A"
   id="stop184" />
				</linearGradient>
				<path
   id="XMLID_6838_"
   style="fill:url(#XMLID_4317_);stroke:#232323;stroke-miterlimit:10"
   d="m 102.2,152.2 -24.5,4.4 c -1,0.2 -1.8,-0.5 -1.8,-1.5 v -18.2 c 0,-1 0.8,-2 1.8,-2.2 l 24.5,-4.4 c 1,-0.2 1.8,0.5 1.8,1.5 V 150 c 0,1 -0.8,2 -1.8,2.2 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_6837_"
   class="st689"
   d="M 102.2,127.3 77.7,131 c -1,0.2 -1.8,-0.5 -1.8,-1.5 v -18.2 c 0,-1 0.8,-2 1.8,-2.2 l 24.5,-3.7 c 1,-0.2 1.8,0.5 1.8,1.5 v 18.2 c 0,1 -0.8,2 -1.8,2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				<path
   id="XMLID_6836_"
   class="st689"
   d="m 102.2,103.9 -24.5,3.7 c -1,0.2 -1.8,-0.5 -1.8,-1.5 v -6.8 c 0,-1 0.8,-2 1.8,-2.2 l 24.5,-3.7 c 1,-0.2 1.8,0.5 1.8,1.5 v 6.8 c 0,1.1 -0.8,2.1 -1.8,2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				<path
   id="XMLID_6835_"
   class="st898"
   d="m 101,126.1 -23.3,3.5 c -1,0.2 -1.8,-0.5 -1.8,-1.4 v -16.6 c 0,-1 0.8,-1.9 1.8,-2.1 L 101,106 c 1,-0.2 1.8,0.5 1.8,1.4 V 124 c -0.1,1 -0.9,1.9 -1.8,2.1 z"
   inkscape:connector-curvature="0"
   style="fill:#a2a599" />
				<path
   id="XMLID_6834_"
   class="st898"
   d="m 101,103.1 -23.3,3.5 c -1,0.2 -1.8,-0.5 -1.8,-1.4 v -5.8 c 0,-1 0.8,-1.9 1.8,-2.1 L 101,93.8 c 1,-0.2 1.8,0.5 1.8,1.4 v 5.8 c -0.1,1 -0.9,1.9 -1.8,2.1 z"
   inkscape:connector-curvature="0"
   style="fill:#a2a599" />
				<path
   id="XMLID_6833_"
   class="st769"
   d="m 58.6,145.9 8.3,3 c 0,0 1.4,-1.8 1,-4.5 l -8.3,-3.3 c -0.1,0.1 -0.1,3.2 -1,4.8 z"
   inkscape:connector-curvature="0"
   style="fill:#68696d" />
				<path
   id="XMLID_6832_"
   class="st479"
   d="m 67.9,139.5 -0.8,4.7 -7.6,-3 c 0,0 -0.2,-2.8 0.5,-4.7 z"
   inkscape:connector-curvature="0"
   style="fill:#505154" />
				<polygon
   id="XMLID_6831_"
   class="st796"
   points="58.6,145.9 58.2,147 65.8,149.5 66.8,149 "
   style="fill:#353638" />
				<polygon
   id="XMLID_6830_"
   class="st796"
   points="68.7,138.2 67.9,139.5 60,136.4 60.5,135.2 "
   style="fill:#353638" />
				<polygon
   id="XMLID_6829_"
   class="st769"
   points="68.7,138.2 69,134.4 60.3,131.3 60.3,135.2 "
   style="fill:#68696d" />
				<polygon
   id="XMLID_6828_"
   class="st479"
   points="59.7,131 59.7,126.6 68,129.5 68,134 "
   style="fill:#505154" />
				<polygon
   id="XMLID_6827_"
   class="st796"
   points="59.7,126.6 59.8,125.1 69,128.5 68,129.5 "
   style="fill:#353638" />
				<path
   id="XMLID_6826_"
   class="st479"
   d="m 59.3,121.4 8.8,2.8 c 0,0 -0.5,-3.7 -1.3,-4.7 L 58.2,117 c -0.1,0 0.2,3.9 1.1,4.4 z"
   inkscape:connector-curvature="0"
   style="fill:#505154" />
				<polygon
   id="XMLID_6825_"
   class="st796"
   points="58.1,117 58.1,115.7 67.3,118.5 66.7,119.5 "
   style="fill:#353638" />
				<g
   id="XMLID_6817_">
					<rect
   id="XMLID_6824_"
   x="81.900002"
   y="50"
   class="st706"
   width="5"
   height="3.4000001"
   style="fill:#99845f" />
					<rect
   id="XMLID_6823_"
   x="86.400002"
   y="50"
   class="st490"
   width="0.30000001"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_6822_"
   x="82.300003"
   y="50"
   class="st490"
   width="0.30000001"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_6821_"
   x="83.199997"
   y="50"
   class="st490"
   width="0.5"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_6820_"
   x="85.300003"
   y="50"
   class="st490"
   width="0.5"
   height="3.4000001"
   style="fill:#544733" />
					<rect
   id="XMLID_6819_"
   x="84.300003"
   y="50"
   class="st490"
   width="0.5"
   height="3.4000001"
   style="fill:#544733" />
					<ellipse
   id="XMLID_6818_"
   class="st630"
   cx="84.400002"
   cy="50"
   rx="2.5"
   ry="0.5"
   style="fill:#c1a880" />
				</g>
				<path
   id="XMLID_6816_"
   class="st736"
   d="m 101.8,137.3 c -0.4,2.4 -2.4,4.4 -4.5,4.4 -2.1,0 -3.5,-2 -3.1,-4.4 0.4,-2.4 2.4,-4.4 4.5,-4.4 2.2,0 3.5,2 3.1,4.4 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
				<path
   id="XMLID_6815_"
   class="st472"
   d="m 101.3,137.3 c -0.3,2.1 -2.1,3.8 -3.9,3.8 -1.8,0 -3,-1.7 -2.6,-3.8 z"
   inkscape:connector-curvature="0"
   style="fill:#1d1d1b" />
				
					<linearGradient
   id="XMLID_4354_"
   gradientUnits="userSpaceOnUse"
   x1="77.699203"
   y1="-17289.68"
   x2="92.230499"
   y2="-17289.68"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop211" />
					<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop213" />
				</linearGradient>
				<path
   id="XMLID_6814_"
   style="fill:url(#XMLID_4354_)"
   d="m 92.1,143.5 c -0.7,4.5 -4.5,8.1 -8.5,8.1 -4,0 -6.5,-3.6 -5.8,-8.1 0.7,-4.5 4.5,-8.1 8.5,-8.1 4,0 6.5,3.7 5.8,8.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_6813_"
   class="st736"
   d="m 91.2,143.7 c -0.6,3.8 -3.9,6.9 -7.3,6.9 -3.4,0 -5.6,-3.1 -5,-6.9 0.6,-3.8 3.9,-6.9 7.3,-6.9 3.4,0 5.7,3.1 5,6.9 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
				<path
   id="XMLID_6812_"
   class="st689"
   d="m 78.8,92.9 -2.6,0.3 c 0,0 -2.6,0.1 -2.4,-3.3 L 76.3,65 69.8,58.5 v -2.6 c 0,0 13.2,0.5 10,11 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				
					<linearGradient
   id="XMLID_4355_"
   gradientUnits="userSpaceOnUse"
   x1="88.382797"
   y1="-17200.258"
   x2="88.382797"
   y2="-17241.895"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop219" />
					<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop221" />
				</linearGradient>
				<path
   id="XMLID_6811_"
   class="st328"
   d="m 79.6,64.6 -2.7,25.2 c 0,0 -0.5,3.4 1.4,3.1 l 26.4,-3.4 c 0,0 2.7,-0.5 2.4,-3.8 l -2.7,-23.5 c 0,0 -0.3,-5.5 -4.3,-6.9 l -7,-2.1 c 0,0 -11.7,-0.8 -23.3,2.8 -0.1,-0.1 11.1,1.4 9.8,8.6 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4355_)" />
				<path
   id="XMLID_6810_"
   class="st923"
   d="m 103.7,63.5 c 0,0 -11.5,-2.5 -23,2.2 l -2.3,19.6 c 0,0 -0.4,2.1 1.8,1.7 L 104,84 c 0,0 1.8,0 1.7,-2.1 z"
   inkscape:connector-curvature="0"
   style="fill:#0d1f30" />
				
					<linearGradient
   id="XMLID_4357_"
   gradientUnits="userSpaceOnUse"
   x1="67.6465"
   y1="-17213.289"
   x2="66.857903"
   y2="-17204.389"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#B2B8D1"
   id="stop226" />
					<stop
   offset="1"
   style="stop-color:#545D70"
   id="stop228" />
				</linearGradient>
				<path
   id="XMLID_6809_"
   style="fill:url(#XMLID_4357_);stroke:#383838;stroke-miterlimit:10"
   d="m 58.6,67.3 7,1.7 1.1,-2.6 c 0,0 3.6,-4 9.4,-4.5 0,0 0.4,-1.7 -0.9,-2.1 L 69.7,58 61.5,60.8 c 0,0.1 -3.6,1.9 -2.9,6.5 z"
   inkscape:connector-curvature="0" />
				
					<linearGradient
   id="XMLID_4358_"
   gradientUnits="userSpaceOnUse"
   x1="65.640602"
   y1="-17211.145"
   x2="76.322304"
   y2="-17211.145"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
					<stop
   offset="0"
   style="stop-color:#B2B8D1"
   id="stop232" />
					<stop
   offset="1"
   style="stop-color:#545D70"
   id="stop234" />
				</linearGradient>
				<path
   id="XMLID_6808_"
   style="fill:url(#XMLID_4358_);stroke:#383838;stroke-miterlimit:10"
   d="m 65.6,69 h 8.7 c 0,0 1.8,0.1 2,-2.8 L 76.1,61 c 0,0 -10.3,0.6 -10.5,8 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_6807_"
   class="st524"
   d="m 64.7,67.9 c 0,0 0,0 0,0 -0.3,0 -0.6,-0.3 -0.5,-0.6 0,-0.2 0.5,-5.4 8.1,-7.2 0.3,-0.1 0.6,0.1 0.6,0.4 0.1,0.3 -0.1,0.6 -0.4,0.6 -6.8,1.7 -7.2,6.2 -7.3,6.3 0.1,0.3 -0.2,0.5 -0.5,0.5 z"
   inkscape:connector-curvature="0"
   style="opacity:0.57999998;fill:#ffffff" />
				<path
   id="XMLID_6806_"
   class="st524"
   d="M 66.9,68.4 H 71 L 72.1,65 c 0,0 -4.1,1 -5.2,3.4 z"
   inkscape:connector-curvature="0"
   style="opacity:0.57999998;fill:#ffffff" />
				<polygon
   id="XMLID_6805_"
   class="st524"
   points="107.4,64 109.3,64 108.7,60.7 "
   style="opacity:0.57999998;fill:#ffffff" />
				<polygon
   id="XMLID_6804_"
   class="st749"
   points="94.5,55.3 83.2,56.2 84.8,58.6 97.3,57.4 "
   style="fill:#666461" />
				<g
   id="XMLID_6795_">
					<polygon
   id="XMLID_6803_"
   class="st1"
   points="82.6,71.6 102,69.6 102,70.3 82.6,72.2 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6802_"
   class="st1"
   points="82.6,72.6 100.2,70.8 100.2,71.4 82.6,73.3 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6801_"
   class="st1"
   points="82.6,76 102,74.1 102,74.7 82.6,76.7 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6800_"
   class="st1"
   points="82.6,78.1 102,76.1 102,76.8 82.6,78.7 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6799_"
   class="st1"
   points="82.6,77.1 100.2,75.3 100.2,75.9 82.6,77.7 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6798_"
   class="st1"
   points="82.6,80.1 102,78.2 102,78.8 82.6,80.8 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6797_"
   class="st1"
   points="82.6,81.1 102,79.1 102,79.8 82.6,81.7 "
   style="fill:#46535b" />
					<polygon
   id="XMLID_6796_"
   class="st1"
   points="82.6,79.1 100.2,77.3 100.2,77.9 82.6,79.8 "
   style="fill:#46535b" />
				</g>
				<circle
   id="XMLID_6794_"
   class="st689"
   cx="92.699997"
   cy="88.199997"
   r="1.9"
   style="fill:#2b2b2b" />
				
					<radialGradient
   id="XMLID_4361_"
   cx="178.4277"
   cy="86.010696"
   r="5.3969998"
   gradientTransform="matrix(0.9218,0,0,1,-71.5053,0)"
   gradientUnits="userSpaceOnUse">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop252" />
					<stop
   offset="1"
   style="stop-color:#707070"
   id="stop254" />
				</radialGradient>
				<ellipse
   id="XMLID_6793_"
   style="fill:url(#XMLID_4361_)"
   cx="92.400002"
   cy="88.199997"
   rx="1.4"
   ry="1.6" />
				<g
   id="XMLID_6782_">
					<ellipse
   id="XMLID_6792_"
   class="st929"
   cx="98.300003"
   cy="146.3"
   rx="2.2"
   ry="2.5"
   style="fill:#0f0f0f" />
					<ellipse
   id="XMLID_6789_"
   class="st628"
   cx="98.599998"
   cy="146.39999"
   rx="1.9"
   ry="2.0999999"
   style="fill:#c12f52" />
					<ellipse
   id="XMLID_6786_"
   class="st573"
   cx="99.199997"
   cy="146.39999"
   rx="1.6"
   ry="1.8"
   style="fill:#f9385d" />
					<ellipse
   id="XMLID_6783_"
   class="st721"
   cx="99.800003"
   cy="145.60001"
   rx="0.60000002"
   ry="0.69999999"
   style="fill:#ff88a4" />
				</g>
				<polygon
   id="XMLID_6781_"
   class="st689"
   points="77.6,112.2 87.2,110.6 87.2,109.2 77.6,110.8 "
   style="fill:#2b2b2b" />
				<polygon
   id="XMLID_6780_"
   class="st689"
   points="100.7,108.3 100.7,107 90.8,108.7 90.8,110 "
   style="fill:#2b2b2b" />
				<polygon
   id="XMLID_6779_"
   class="st689"
   points="77.6,121.8 87.2,120.3 87.2,119 77.6,120.4 "
   style="fill:#2b2b2b" />
				<polygon
   id="XMLID_6778_"
   class="st689"
   points="100.7,118.3 100.7,116.9 90.8,118.4 90.8,119.8 "
   style="fill:#2b2b2b" />
				<g
   id="XMLID_6733_">
					<path
   id="XMLID_6771_"
   d="m 83.5,114 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z M 83,117.7 V 116 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.3,0 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.1,1.4 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.4,0.4 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_6764_"
   d="m 83.5,122.9 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.6 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.3,0.1 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.1,1.3 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.4,0.4 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 L 85.2,126 v -1.4 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_6757_"
   d="m 99,120.6 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.6 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.3,0.1 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.1,1.3 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.4,0.5 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_6751_"
   d="m 90.3,116.4 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.4,0 -2.1,0.4 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.7,-0.3 z m -0.4,-4.1 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.2,1.6 0.3,0.2 -0.3,0.3 -1.7,0.3 -0.3,-0.2 0.3,-0.3 z m 0,-0.2 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_6744_"
   d="m 94.1,112.2 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.5,3.6 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.3,0.1 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.2 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.1,1.4 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.4,0.4 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 V 114 Z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_6742_"
   d="m 97.5,115.6 -0.5,0.1 v -0.5 l 0.5,-0.1 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_6734_"
   d="m 98.7,111.4 v 1.2 l -0.4,0.5 -0.1,-0.1 v -1.7 z m -0.6,3.6 v -1.7 l 0.1,-0.2 0.4,0.3 v 1.2 z m 2.3,0.1 -1.9,0.3 c -0.2,0 -0.3,-0.1 -0.3,-0.3 l 0.5,-0.3 1.6,-0.3 z m -0.2,-4.2 -1.5,0.3 -0.5,-0.1 c 0,-0.2 0.2,-0.3 0.3,-0.4 l 1.9,-0.3 z m 0.2,1.6 0.3,0.2 -0.3,0.3 -1.7,0.3 -0.3,-0.2 0.3,-0.3 z m 0,-0.2 v -1.4 l 0.2,-0.6 c 0.2,0 0.3,0.1 0.3,0.3 v 1.8 l -0.1,0.2 z m 0.3,0.4 0.1,0.1 v 1.8 c 0,0.2 -0.2,0.3 -0.3,0.4 l -0.2,-0.5 v -1.4 z"
   inkscape:connector-curvature="0" />
				</g>
				<g
   id="XMLID_6724_">
					<path
   id="XMLID_6725_"
   class="st689"
   d="m 94.2,101.1 v -0.7 l 0.6,-0.1 v -1.9 l -0.6,0.1 v -0.7 c 0,-0.5 -0.4,-0.8 -0.8,-0.7 L 86,98.3 c -0.5,0.1 -0.8,0.5 -0.8,1 v 3.4 c 0,0.5 0.4,0.8 0.8,0.7 l 7.4,-1.3 c 0.4,-0.1 0.8,-0.6 0.8,-1 z m -8.2,1.7 c -0.2,0 -0.3,-0.1 -0.3,-0.2 v -3.4 c 0,-0.2 0.1,-0.3 0.3,-0.3 l 7.4,-1.3 c 0.2,0 0.3,0.1 0.3,0.2 v 3.4 c 0,0.2 -0.1,0.3 -0.3,0.3 z m 0.1,-0.3 V 99.2 L 87.3,99 v 3.3 z m 1.5,-0.3 v -3.3 l 1.2,-0.2 v 3.3 z m 1.5,-0.3 v -3.3 l 1.2,-0.2 v 3.3 z m 1.5,-0.2 v -3.3 l 1.2,-0.2 v 3.3 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
				</g>
			</g>
		</g>
		<linearGradient
   id="XMLID_4362_"
   gradientUnits="userSpaceOnUse"
   x1="23.4063"
   y1="95.8936"
   x2="140.5703"
   y2="95.8936">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop279" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop281" />
		</linearGradient>
		
			<circle
   id="XMLID_1119_"
   style="fill:none;stroke:url(#XMLID_4362_);stroke-width:3;stroke-miterlimit:10"
   cx="82"
   cy="95.900002"
   r="57.099998" />
	</g>
	<g
   id="img3"
   :class="[{'': vistos[2]} ]" @click="darVisto(2)"
   inkscape:label="#XMLID_6108_">
		<linearGradient
   id="XMLID_4364_"
   gradientUnits="userSpaceOnUse"
   x1="151.4648"
   y1="95.430702"
   x2="268.62991"
   y2="95.430702">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop286" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop288" />
		</linearGradient>
		
			<circle
   id="XMLID_6125_"
   style="fill:#ffffff;stroke:url(#XMLID_4364_);stroke-width:3;stroke-miterlimit:10"
   cx="210"
   cy="95.400002"
   r="57.099998" />
		<g
   id="XMLID_5857_">
			<linearGradient
   id="XMLID_4365_"
   gradientUnits="userSpaceOnUse"
   x1="248.47459"
   y1="54.5313"
   x2="248.47459"
   y2="124.4328">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop292" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop294" />
			</linearGradient>
			<path
   id="XMLID_6501_"
   style="fill:url(#XMLID_4365_)"
   d="m 243.9,61.6 c -1.1,-1.1 -2.9,-1.1 -4,0 -1.1,1.1 -1.1,2.9 0,4 8,8 12.4,18.6 12.4,29.8 0,11.2 -4.4,21.9 -12.4,29.8 -1.1,1.1 -1.1,2.9 0,4 1.1,1.1 2.9,1.1 4,0 9,-9 14,-21 14,-33.8 0,-12.8 -5,-24.8 -14,-33.8 z m 0,0"
   inkscape:connector-curvature="0" />
			<linearGradient
   id="XMLID_4368_"
   gradientUnits="userSpaceOnUse"
   x1="238.23441"
   y1="54.5303"
   x2="238.23441"
   y2="124.4332">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop298" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop300" />
			</linearGradient>
			<path
   id="XMLID_6489_"
   class="st333"
   d="m 235.4,70 c -1.1,-1.1 -2.9,-1.1 -4,0 -1.1,1.1 -1.1,2.9 0,4 5.7,5.7 8.8,13.3 8.8,21.4 0,8.1 -3.1,15.7 -8.8,21.4 -1.1,1.1 -1.1,2.9 0,4 1.1,1.1 2.9,1.1 4,0 6.8,-6.8 10.5,-15.8 10.5,-25.3 0,-9.7 -3.8,-18.7 -10.5,-25.5 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4368_)" />
			<path
   id="XMLID_6400_"
   class="st526"
   d="m 226.9,78.5 c -1.1,-1.1 -2.9,-1.1 -4,0 -1.1,1.1 -1.1,2.9 0,4 3.4,3.4 5.3,8 5.3,12.9 0,4.9 -1.9,9.4 -5.3,12.9 -1.1,1.1 -1.1,2.9 0,4 1.1,1.1 2.9,1.1 4,0 4.5,-4.5 7,-10.5 7,-16.8 0,-6.3 -2.5,-12.5 -7,-17 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#23cad9" />
			<linearGradient
   id="XMLID_4369_"
   gradientUnits="userSpaceOnUse"
   x1="171.6201"
   y1="54.5313"
   x2="171.6201"
   y2="124.4328">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop305" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop307" />
			</linearGradient>
			<path
   id="XMLID_6112_"
   style="fill:url(#XMLID_4369_)"
   d="m 167.8,95.4 c 0,-11.3 4.4,-21.9 12.4,-29.8 1.1,-1.1 1.1,-2.9 0,-4 -1.1,-1.1 -2.9,-1.1 -4,0 -9,9 -14,21 -14,33.8 0,12.8 5,24.8 14,33.8 1.1,1.1 2.9,1.1 4,0 1.1,-1.1 1.1,-2.9 0,-4 -8,-8 -12.4,-18.6 -12.4,-29.8 z m 0,0"
   inkscape:connector-curvature="0" />
			<linearGradient
   id="XMLID_4371_"
   gradientUnits="userSpaceOnUse"
   x1="181.85941"
   y1="54.5303"
   x2="181.85941"
   y2="124.4332">
				<stop
   offset="0"
   style="stop-color:#C7EE95"
   id="stop311" />
				<stop
   offset="1"
   style="stop-color:#9BE89F"
   id="stop313" />
			</linearGradient>
			<path
   id="XMLID_5945_"
   class="st334"
   d="m 179.8,95.4 c 0,-8.1 3.1,-15.7 8.8,-21.4 1.1,-1.1 1.1,-2.9 0,-4 -1.1,-1.1 -2.9,-1.1 -4,0 -6.8,6.8 -10.5,15.8 -10.5,25.3 0,9.6 3.7,18.6 10.5,25.3 1.1,1.1 2.9,1.1 4,0 1.1,-1.1 1.1,-2.9 0,-4 -5.6,-5.6 -8.8,-13.2 -8.8,-21.2 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4371_)" />
			<path
   id="XMLID_5930_"
   class="st526"
   d="m 197.2,78.5 c -1.1,-1.1 -2.9,-1.1 -4,0 -4.5,4.5 -7,10.5 -7,16.8 0,6.3 2.5,12.3 7,16.8 1.1,1.1 2.9,1.1 4,0 1.1,-1.1 1.1,-2.9 0,-4 -3.4,-3.4 -5.3,-8 -5.3,-12.9 0,-4.9 1.9,-9.4 5.3,-12.9 1.1,-0.9 1.1,-2.7 0,-3.8 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#23cad9" />
			<path
   id="XMLID_5861_"
   class="st526"
   d="m 210,83.6 c -6.5,0 -11.8,5.3 -11.8,11.8 0,6.5 5.3,11.8 11.8,11.8 6.5,0 11.8,-5.3 11.8,-11.8 0.1,-6.5 -5.2,-11.8 -11.8,-11.8 z m 0,0"
   inkscape:connector-curvature="0"
   style="fill:#23cad9" />
		</g>
	</g>
	<g
   id="img5"
   :class="[{'': vistos[4]} ]" @click="darVisto(4)"
   inkscape:label="#XMLID_7389_">
		<linearGradient
   id="XMLID_4376_"
   gradientUnits="userSpaceOnUse"
   x1="316.50491"
   y1="95.430702"
   x2="433.66989"
   y2="95.430702">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop321" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop323" />
		</linearGradient>
		
			<circle
   id="XMLID_2343_"
   style="fill:#ffffff;stroke:url(#XMLID_4376_);stroke-width:3;stroke-miterlimit:10"
   cx="375.10001"
   cy="95.400002"
   r="57.099998" />
		<g
   id="XMLID_6710_">
			<path
   id="XMLID_7221_"
   class="st4"
   d="m 351.6,65.2 c 0.2,-2.6 0.9,-5.1 2.2,-7.3 1.3,-2.2 5.1,-7 7.6,-3.6 1.3,1.8 1.7,4.3 1.4,6.4 -0.3,2.5 -2.2,4.6 -2.5,7.1 -0.3,2.8 1.6,4.8 4.3,4.1 3,-0.8 4.2,-4.2 5.2,-6.9 0.7,-2.1 0.7,-4 0.8,-6.1 0.2,-3 2.1,-4.9 4.2,-7 3.1,-3.1 7.4,-5.7 11.9,-3.7 2.3,1 4.2,2.8 6.1,4.3 1.1,0.8 3.2,1.9 1.5,3.3 -0.3,0.2 -1.3,0.5 -1.6,0.7 -1.4,0.7 -2.6,1.8 -3.5,3.2 -2.7,4.1 -2.1,9.2 -1.5,13.8 0,0.3 1.9,-0.1 1.9,-0.5 -0.6,-4.7 -1.2,-10 1.7,-14 1.2,-1.6 2.3,-2 4,-2.9 0.2,-0.1 0.6,-0.1 0.8,-0.3 0.9,-0.9 1,-1.4 0,-2.5 -4.9,-5.3 -11.5,-8.2 -18.1,-4.8 -3.1,1.6 -6.2,4.5 -8.1,7.4 -1.1,1.7 -1.1,3.1 -1.1,5.1 -0.1,2.8 -1,5.3 -2.3,7.8 -0.5,0.9 -1.6,2.7 -2.9,2.2 -0.8,-0.3 -1.3,-2 -1.3,-2.8 -0.2,-2.5 1.8,-4.6 2.3,-6.9 0.7,-2.8 0.2,-7.9 -3.1,-9.1 -2.2,-0.8 -4.7,0.9 -6.2,2.2 -3.3,2.9 -5.2,6.9 -5.5,11.3 -0.1,0.2 1.8,0 1.8,-0.5 z"
   inkscape:connector-curvature="0"
   style="fill:#aaaaaa" />
			<g
   id="XMLID_7148_">
				<g
   id="XMLID_7217_">
					<linearGradient
   id="XMLID_4432_"
   gradientUnits="userSpaceOnUse"
   x1="389.37299"
   y1="66.202103"
   x2="389.37299"
   y2="140.0081">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop328" />
						<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop330" />
					</linearGradient>
					<path
   id="XMLID_7220_"
   class="st341"
   d="m 406.8,70.5 c -5.4,-3 -17.5,-3.1 -17.5,-3.1 0,0 -12.1,0 -17.5,3.1 0,0 -2.8,9.7 -1.6,17.6 0,0 6.4,19.7 2.6,36.8 0,0 -1.1,9.8 3.7,12.8 l 12.7,1 12.7,-1 c 4.8,-3 3.7,-12.8 3.7,-12.8 -3.7,-17.1 2.6,-36.8 2.6,-36.8 1.5,-7.9 -1.4,-17.6 -1.4,-17.6 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4432_)" />
					<linearGradient
   id="XMLID_4437_"
   gradientUnits="userSpaceOnUse"
   x1="389.37399"
   y1="138.86909"
   x2="389.37399"
   y2="67.543198">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop334" />
						<stop
   offset="1"
   style="stop-color:#707070"
   id="stop336" />
					</linearGradient>
					<path
   id="XMLID_7219_"
   style="fill:url(#XMLID_4437_)"
   d="m 406.1,71.7 c -5.2,-2.9 -16.8,-3 -16.8,-3 0,0 -11.6,0 -16.8,3 0,0 -2.7,9.4 -1.5,17 0,0 6.1,19 2.5,35.5 0,0 -1,9.5 3.6,12.3 l 12.2,0.9 12.1,-0.9 c 4.6,-2.8 3.6,-12.3 3.6,-12.3 -3.6,-16.5 2.5,-35.5 2.5,-35.5 1.3,-7.6 -1.4,-17 -1.4,-17 z"
   inkscape:connector-curvature="0" />
					<linearGradient
   id="XMLID_4439_"
   gradientUnits="userSpaceOnUse"
   x1="389.37299"
   y1="137.52831"
   x2="389.37299"
   y2="66.473396">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop340" />
						<stop
   offset="1"
   style="stop-color:#1D3D4A"
   id="stop342" />
					</linearGradient>
					<path
   id="XMLID_7218_"
   style="fill:url(#XMLID_4439_)"
   d="m 405.5,72.3 c -5,-2.9 -16.1,-2.9 -16.1,-2.9 0,0 -11.2,0 -16.1,2.9 0,0 -2.6,9.2 -1.5,16.7 0,0 5.9,18.7 2.4,34.9 0,0 -1,9.3 3.4,12.1 l 11.7,0.9 11.7,-0.9 c 4.4,-2.8 3.4,-12.1 3.4,-12.1 C 401.1,107.7 407,89 407,89 c 1.1,-7.5 -1.5,-16.7 -1.5,-16.7 z"
   inkscape:connector-curvature="0" />
				</g>
				<path
   id="XMLID_7216_"
   class="st894"
   d="m 408.5,84.3 v 0.9 c -1.9,0.6 -2,-0.8 -2,-0.8 1.2,-3.5 -1.1,-5.9 -1.1,-5.9 l -2,-2.3 c -1.4,-1.7 3.7,-3.7 3.7,-3.7 l 0.2,1.1 c 1.4,-1.4 -0.4,-4.7 -0.4,-4.7 -2.7,-2.3 -5,-0.4 -5,-0.4 l 0.9,0.8 c 1.3,0.3 -0.3,2.3 -0.3,2.3 -1.4,2.3 -2.7,1 -2.7,1 -4.6,-6.1 -5.7,-5.5 -5.7,-5.5 h -4.7 -4.7 c 0,0 -1.1,-0.6 -5.7,5.5 0,0 -1.3,1.3 -2.7,-1 0,0 -1.6,-2 -0.3,-2.3 l 0.9,-0.8 c 0,0 -2.3,-1.8 -5,0.4 0,0 -1.8,3.4 -0.4,4.7 l 0.2,-1.1 c 0,0 5.1,2 3.7,3.7 l -2,2.3 c 0,0 -2.3,2.4 -1.1,5.9 0,0 -0.1,1.4 -2,0.8 v -0.9 c 0,0 -1.6,0.8 -1,2.6 l 0.6,2.3 c 0,0 0.9,0.9 2.8,0.9 0,0 1.5,-0.2 1.8,4.4 0,0 0.3,3.5 -0.5,3.6 l -1.2,0.3 -0.3,-1.6 c 0,0 -0.7,0.1 -0.8,1.9 l 0.2,2.8 c 0,0 0.4,1.4 1.6,1.2 0,0 2.2,-0.4 2.3,1.4 l 0.2,4.6 c 0,0 0.1,1.6 -1,1.6 h -1 l -0.1,-2.4 c 0,0 -1.1,-0.2 -1.1,1.1 v 4.1 c 0,0 0.5,1.6 2.2,1.4 0,0 1.4,-0.2 1.4,2.3 l -0.2,3.6 c 0,0 -0.3,1.7 -1.9,1.2 0,0 -0.7,-0.1 -0.7,-0.6 l 0.3,-2.7 c 0,0 -1.2,-0.4 -1.4,0.9 l -0.5,5 0.5,0.9 c 0,0 -0.5,3.9 0.4,7.2 0,0 1.1,4.8 4.1,6 l 1.1,-0.6 c 0,0 5.8,0.8 11.2,0.6 5.3,0.2 11.2,-0.6 11.2,-0.6 l 1.1,0.6 c 3,-1.2 4.1,-6 4.1,-6 0.9,-3.2 0.4,-7.2 0.4,-7.2 l 0.5,-0.9 -0.5,-5 c -0.2,-1.3 -1.4,-0.9 -1.4,-0.9 l 0.3,2.7 c 0.1,0.5 -0.7,0.6 -0.7,0.6 -1.6,0.5 -1.9,-1.2 -1.9,-1.2 l -0.2,-3.6 c 0,-2.4 1.4,-2.3 1.4,-2.3 1.7,0.1 2.2,-1.4 2.2,-1.4 V 109 c 0,-1.2 -1.1,-1.1 -1.1,-1.1 l -0.1,2.4 h -1 c -1,0 -1,-1.6 -1,-1.6 l 0.2,-4.6 c 0.1,-1.8 2.3,-1.4 2.3,-1.4 1.2,0.2 1.6,-1.2 1.6,-1.2 l 0.2,-2.8 c -0.1,-1.7 -0.8,-1.9 -0.8,-1.9 l -0.3,1.6 -1.2,-0.3 c -0.8,-0.1 -0.5,-3.6 -0.5,-3.6 0.3,-4.6 1.8,-4.4 1.8,-4.4 1.9,0 2.8,-0.9 2.8,-0.9 l 0.6,-2.3 c 0.8,-1.8 -0.8,-2.6 -0.8,-2.6 z"
   inkscape:connector-curvature="0"
   style="fill:#727272" />
				<linearGradient
   id="XMLID_4440_"
   gradientUnits="userSpaceOnUse"
   x1="389.37399"
   y1="140.56641"
   x2="389.37399"
   y2="66.688499">
					<stop
   offset="0"
   style="stop-color:#353535"
   id="stop348" />
					<stop
   offset="1"
   style="stop-color:#4D494D"
   id="stop350" />
				</linearGradient>
				<path
   id="XMLID_7215_"
   class="st342"
   d="m 408.6,84.6 v 0.9 c -1.9,0.6 -2,-0.8 -2,-0.8 1.3,-3.5 -1.1,-6 -1.1,-6 l -2,-2.3 c -1.4,-1.7 3.8,-3.7 3.8,-3.7 l 0.2,1.1 c 1.4,-1.4 -0.4,-4.8 -0.4,-4.8 -2.7,-2.3 -5,-0.4 -5,-0.4 l 0.9,0.8 c 1.3,0.3 -0.3,2.3 -0.3,2.3 -1.4,2.3 -2.7,1 -2.7,1 -4.6,-6.2 -5.7,-5.6 -5.7,-5.6 h -4.8 -4.8 c 0,0 -1.1,-0.6 -5.7,5.6 0,0 -1.4,1.3 -2.7,-1 0,0 -1.6,-2 -0.3,-2.3 l 0.9,-0.8 c 0,0 -2.3,-1.9 -5,0.4 0,0 -1.8,3.4 -0.4,4.8 l 0.2,-1.1 c 0,0 5.1,2 3.8,3.7 l -2,2.3 c 0,0 -2.3,2.5 -1.1,6 0,0 -0.1,1.5 -2,0.8 v -0.9 c 0,0 -1.7,0.8 -1,2.6 l 0.6,2.3 c 0,0 0.9,0.9 2.8,0.9 0,0 1.5,-0.2 1.8,4.5 0,0 0.3,3.5 -0.5,3.6 l -1.2,0.3 -0.3,-1.6 c 0,0 -0.7,0.1 -0.8,1.9 l 0.2,2.9 c 0,0 0.4,1.4 1.7,1.2 0,0 2.2,-0.4 2.3,1.4 l 0.2,4.7 c 0,0 0.1,1.6 -1,1.6 h -1 l -0.1,-2.5 c 0,0 -1.1,-0.2 -1.1,1.1 v 4.2 c 0,0 0.5,1.6 2.2,1.4 0,0 1.4,-0.2 1.4,2.3 l -0.2,3.7 c 0,0 -0.3,1.7 -1.9,1.2 0,0 -0.7,-0.1 -0.7,-0.6 l 0.3,-2.8 c 0,0 -1.2,-0.4 -1.4,0.9 l -0.5,5 0.5,0.9 c 0,0 -0.5,4 0.4,7.3 0,0 1.1,4.8 4.1,6.1 l 1.1,-0.6 c 0,0 5.9,0.8 11.3,0.6 5.4,0.2 11.3,-0.6 11.3,-0.6 l 1.1,0.6 c 3,-1.2 4.1,-6.1 4.1,-6.1 0.9,-3.3 0.4,-7.3 0.4,-7.3 l 0.5,-0.9 -0.5,-5 c -0.2,-1.4 -1.4,-0.9 -1.4,-0.9 l 0.3,2.8 c 0.1,0.5 -0.7,0.6 -0.7,0.6 -1.6,0.5 -1.9,-1.2 -1.9,-1.2 l -0.2,-3.7 c 0,-2.5 1.4,-2.3 1.4,-2.3 1.7,0.1 2.2,-1.4 2.2,-1.4 v -4.2 c 0,-1.2 -1.1,-1.1 -1.1,-1.1 l -0.1,2.5 h -1 c -1,0 -1,-1.6 -1,-1.6 l 0.2,-4.7 c 0.1,-1.8 2.3,-1.4 2.3,-1.4 1.2,0.2 1.6,-1.2 1.6,-1.2 l 0.2,-2.9 c -0.1,-1.8 -0.8,-1.9 -0.8,-1.9 l -0.3,1.6 -1.2,-0.3 c -0.8,-0.1 -0.5,-3.6 -0.5,-3.6 0.3,-4.7 1.8,-4.5 1.8,-4.5 2,0 2.8,-0.9 2.8,-0.9 l 0.6,-2.3 c 0.6,-1.8 -1.1,-2.6 -1.1,-2.6 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4440_)" />
				<g
   id="XMLID_7210_">
					<path
   id="XMLID_7214_"
   class="st546"
   d="M 405.4,80.6 398,72.5 c -2.1,-2.7 -4.2,-2.4 -4.2,-2.4 h -4.5 -4.5 c 0,0 -2.1,-0.2 -4.2,2.4 l -7.4,8.1 c 0,0 -2,2.7 1.5,4.9 0,0 6.4,2.9 14.5,2.6 8.1,0.4 14.5,-2.6 14.5,-2.6 3.7,-2.2 1.7,-4.9 1.7,-4.9 z"
   inkscape:connector-curvature="0"
   style="fill:#282828" />
					<path
   id="XMLID_7211_"
   class="st750"
   d="m 390.7,88.5 c -0.4,0 -0.9,0 -1.4,0 -8.1,0.4 -14.6,-2.6 -14.7,-2.6 v 0 c -1.3,-0.8 -2,-1.8 -2.2,-2.9 -0.3,-1.4 0.6,-2.6 0.6,-2.6 v 0 l 7.4,-8.1 c 2.1,-2.7 4.2,-2.6 4.5,-2.6 h 8.9 c 0.3,0 2.4,-0.1 4.5,2.6 l 7.4,8.1 c 0,0 0.9,1.2 0.6,2.6 -0.2,1.1 -0.9,2 -2.2,2.9 v 0 c -0.1,0 -5.9,2.6 -13.4,2.6 z m -1.3,-0.7 v 0 c 7.7,0.3 13.9,-2.3 14.3,-2.5 1.1,-0.7 1.7,-1.5 1.9,-2.4 0.2,-1.1 -0.4,-1.9 -0.5,-2 l -7.4,-8.1 c -1.9,-2.5 -3.8,-2.3 -3.9,-2.3 v 0 h -9 c -0.1,0 -2,-0.2 -3.9,2.3 v 0 l -7.4,8.1 c -0.1,0.1 -0.7,1 -0.5,2 0.2,0.9 0.8,1.7 1.9,2.4 0.5,0.1 6.8,2.8 14.5,2.5 z"
   inkscape:connector-curvature="0"
   style="fill:#666666" />
				</g>
				<g
   id="XMLID_7188_">
					<path
   id="XMLID_7207_"
   class="st795"
   d="m 376.9,98.1 c 0,0 11.4,1.9 24.9,0 l -0.7,-1.5 h -23.5 z"
   inkscape:connector-curvature="0"
   style="fill:#353535" />
					<path
   id="XMLID_7204_"
   class="st338"
   d="m 377.6,96.6 -0.7,1.5 c 0,0 -2.5,-2.5 -2.3,-11.4 L 377,90 Z"
   inkscape:connector-curvature="0"
   style="fill:#4f4d4f" />
					<path
   id="XMLID_7201_"
   class="st338"
   d="m 401.1,96.6 0.7,1.5 c 0,0 2.5,-2.5 2.3,-11.4 l -2.4,3.3 z"
   inkscape:connector-curvature="0"
   style="fill:#4f4d4f" />
					<path
   id="XMLID_7198_"
   class="st716"
   d="m 389.3,89 c -8.5,0.4 -14.6,-2.3 -14.6,-2.3 0.1,1.4 1.6,3.3 1.6,3.3 2.5,1.3 13,0.8 13,0.8 0,0 10.5,0.4 13,-0.8 0,0 1.5,-1.9 1.6,-3.3 0,0 -6.1,2.7 -14.6,2.3 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
					<linearGradient
   id="XMLID_4441_"
   gradientUnits="userSpaceOnUse"
   x1="389.27341"
   y1="97.3965"
   x2="389.27341"
   y2="89.886299">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop361" />
						<stop
   offset="1"
   style="stop-color:#4D494D"
   id="stop363" />
					</linearGradient>
					<path
   id="XMLID_7197_"
   style="fill:url(#XMLID_4441_)"
   d="m 389.8,90.4 v 0 c -0.2,0 -0.4,0 -0.6,0 -0.2,0 -0.4,0 -0.6,0 v 0 c -5.8,0 -12.4,-0.4 -12.4,-0.4 0.1,2.6 1.3,6.6 1.3,6.6 h 11.1 1.1 11.1 c 0,0 1.3,-4.1 1.3,-6.6 0.2,0 -6.5,0.4 -12.3,0.4 z"
   inkscape:connector-curvature="0" />
					<rect
   id="XMLID_7194_"
   x="378.39999"
   y="91.400002"
   class="st546"
   width="14.7"
   height="4.3000002"
   style="fill:#282828" />
					<g
   id="XMLID_7189_">
						<circle
   id="XMLID_7193_"
   class="st546"
   cx="397.70001"
   cy="93.5"
   r="2.0999999"
   style="fill:#282828" />
						<path
   id="XMLID_7190_"
   class="st639"
   d="m 397.7,95.8 c -1.3,0 -2.3,-1 -2.3,-2.3 0,-1.3 1,-2.3 2.3,-2.3 1.3,0 2.3,1 2.3,2.3 0,1.3 -1,2.3 -2.3,2.3 z m 0,-4.3 c -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 1.1,0 2,-0.9 2,-2 0,-1.1 -0.9,-2 -2,-2 z"
   inkscape:connector-curvature="0"
   style="fill:#93837a" />
					</g>
				</g>
				<path
   id="XMLID_7185_"
   class="st716"
   d="m 398.2,117.9 h -17.6 c -1.4,0 -2.5,-1.1 -2.5,-2.5 v -8.6 c 0,-2.8 2.2,-5 5,-5 h 12.5 c 2.8,0 5,2.2 5,5 v 8.6 c 0,1.4 -1.1,2.5 -2.4,2.5 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
				<linearGradient
   id="XMLID_4442_"
   gradientUnits="userSpaceOnUse"
   x1="389.37399"
   y1="102.0439"
   x2="389.37399"
   y2="117.1658">
					<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop373" />
					<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop375" />
				</linearGradient>
				<path
   id="XMLID_7184_"
   style="fill:url(#XMLID_4442_)"
   d="m 394.6,116.5 h -10.5 c -2.8,0 -5,-2.2 -5,-5 v -4.1 c 0,-2.8 2.2,-5 5,-5 h 10.5 c 2.8,0 5,2.2 5,5 v 4.1 c 0,2.8 -2.2,5 -5,5 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7181_"
   class="st716"
   d="M 377.8,118.6 H 401 l 1.1,6.8 c 0,0 -12.1,5.8 -25.5,0 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
				<path
   id="XMLID_7178_"
   class="st739"
   d="m 376.7,125.2 h 25.5 l 1.2,6.8 c 0,0 -13.3,5.8 -28,0 z"
   inkscape:connector-curvature="0"
   style="opacity:0.27000002;fill:#605c60" />
				<path
   id="XMLID_7175_"
   class="st875"
   d="m 394.1,70.8 h -4.6 -0.3 -4.6 c 0,0 -2.8,0.4 -3.7,2.7 l 2.6,7.5 h 5.6 0.3 5.6 l 2.6,-7.5 c -0.6,-2.3 -3.5,-2.7 -3.5,-2.7 z"
   inkscape:connector-curvature="0"
   style="fill:#3a3a3a" />
				<rect
   id="XMLID_7172_"
   x="384.79999"
   y="73.5"
   class="st697"
   width="9.1999998"
   height="3.5999999"
   style="fill:#c7ee95" />
				<circle
   id="XMLID_7171_"
   class="st472"
   cx="389.39999"
   cy="84.5"
   r="1.7"
   style="fill:#1d1d1b" />
				<g
   id="XMLID_7166_">
					<linearGradient
   id="XMLID_4445_"
   gradientUnits="userSpaceOnUse"
   x1="389.37299"
   y1="127.9648"
   x2="389.37299"
   y2="119.0264">
						<stop
   offset="0"
   style="stop-color:#353535"
   id="stop384" />
						<stop
   offset="1"
   style="stop-color:#4D494D"
   id="stop386" />
					</linearGradient>
					<path
   id="XMLID_7170_"
   style="fill:url(#XMLID_4445_)"
   d="m 378.4,119 h 22 l 1.1,5.7 c 0,0 -11.5,4.9 -24.2,0 z"
   inkscape:connector-curvature="0" />
					<path
   id="XMLID_7167_"
   class="st546"
   d="m 389.2,127.1 c -3.6,0 -7.7,-0.5 -11.9,-2.2 l -0.1,-0.1 1.2,-6 h 22.3 l 1.1,6 -0.1,0.1 c -0.2,0 -5.4,2.2 -12.5,2.2 z m -11.7,-2.5 c 11.7,4.4 22.5,0.5 23.8,0 l -1,-5.4 h -21.7 z"
   inkscape:connector-curvature="0"
   style="fill:#282828" />
				</g>
				<g
   id="XMLID_7163_">
					
						<rect
   id="XMLID_7165_"
   x="384.60001"
   y="118.8"
   transform="matrix(0.953,0.3031,-0.3031,0.953,55.3167,-110.8488)"
   class="st546"
   width="0.40000001"
   height="7.9000001"
   style="fill:#282828" />
					
						<rect
   id="XMLID_7164_"
   x="390"
   y="122.6"
   transform="matrix(0.304,0.9527,-0.9527,0.304,391.1588,-289.8544)"
   class="st546"
   width="7.9000001"
   height="0.40000001"
   style="fill:#282828" />
				</g>
				<g
   id="XMLID_7149_">
					<polygon
   id="XMLID_7160_"
   class="st716"
   points="381.5,124 379.3,121.2 383.7,121.2 "
   style="fill:#605c60" />
					<polygon
   id="XMLID_7157_"
   class="st716"
   points="397.7,121.2 395.5,124 399.9,124 "
   style="fill:#605c60" />
					<g
   id="XMLID_7150_">
						<g
   id="XMLID_6692_">
							<path
   id="XMLID_6695_"
   class="st716"
   d="m 390,120.6 v 0.7 c 0.7,0.3 1.1,0.9 1.1,1.6 0,1 -0.8,1.8 -1.8,1.8 -1,0 -1.8,-0.8 -1.8,-1.8 0,-0.8 0.5,-1.4 1.1,-1.6 v -0.7 c -1,0.3 -1.8,1.2 -1.8,2.3 0,1.3 1.1,2.4 2.4,2.4 1.3,0 2.4,-1.1 2.4,-2.4 0.2,-1.1 -0.6,-2 -1.6,-2.3 z"
   inkscape:connector-curvature="0"
   style="fill:#605c60" />
							<rect
   id="XMLID_6693_"
   x="389"
   y="119.9"
   class="st716"
   width="0.80000001"
   height="3.4000001"
   style="fill:#605c60" />
						</g>
					</g>
				</g>
			</g>
			<g
   id="XMLID_6711_">
				<ellipse
   id="XMLID_7145_"
   class="st527"
   cx="350.70001"
   cy="136"
   rx="11.1"
   ry="3.2"
   style="fill:#f2f2f2" />
				<rect
   id="XMLID_7142_"
   x="349.10001"
   y="61.599998"
   class="st339"
   width="3.5999999"
   height="3.9000001"
   style="fill:#4f514c" />
				<rect
   id="XMLID_7139_"
   x="351.89999"
   y="73.900002"
   class="st339"
   width="8.8000002"
   height="2"
   style="fill:#4f514c" />
				<path
   id="XMLID_7094_"
   class="st910"
   d="m 350.9,137 v 0 c -4.6,0 -8.3,-0.8 -8.3,-3 V 92.6 c 0,-4.6 3.8,-8.3 8.3,-8.3 v 0 c 4.6,0 8.3,3.8 8.3,8.3 V 134 c 0,2.8 -3.7,3 -8.3,3 z"
   inkscape:connector-curvature="0"
   style="fill:#a4bcc1" />
				<ellipse
   id="XMLID_7050_"
   class="st17"
   cx="350.89999"
   cy="85.800003"
   rx="5.0999999"
   ry="2"
   style="fill:#7c9da5" />
				<rect
   id="XMLID_6791_"
   x="348.10001"
   y="64.300003"
   class="st622"
   width="5.5999999"
   height="21.5"
   style="fill:#918e91" />
				<g
   id="XMLID_6714_">
					<g
   id="XMLID_6784_">
						<circle
   id="XMLID_6790_"
   class="st736"
   cx="350.89999"
   cy="75"
   r="4.5999999"
   style="fill:#ffffff" />
						<path
   id="XMLID_6785_"
   class="st472"
   d="m 350.9,80 c -2.7,0 -4.9,-2.2 -4.9,-4.9 0,-2.7 2.2,-4.9 4.9,-4.9 2.7,0 4.9,2.2 4.9,4.9 0,2.7 -2.2,4.9 -4.9,4.9 z m 0,-9.2 c -2.4,0 -4.3,1.9 -4.3,4.3 0,2.4 1.9,4.3 4.3,4.3 2.4,0 4.3,-1.9 4.3,-4.3 0,-2.4 -1.9,-4.3 -4.3,-4.3 z"
   inkscape:connector-curvature="0"
   style="fill:#1d1d1b" />
					</g>
					<circle
   id="XMLID_6715_"
   class="st346"
   cx="350.89999"
   cy="75"
   r="1.4"
   style="fill:#b0cad1" />
				</g>
			</g>
		</g>
	</g>
	<g
   id="img6"
   :class="[{'': vistos[5]} ]" @click="darVisto(5)"
   inkscape:label="#XMLID_4182_">
		<linearGradient
   id="XMLID_4477_"
   gradientUnits="userSpaceOnUse"
   x1="403.00391"
   y1="257.31149"
   x2="520.16803"
   y2="257.31149">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop417" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop419" />
		</linearGradient>
		
			<circle
   id="XMLID_2352_"
   style="fill:#ffffff;stroke:url(#XMLID_4477_);stroke-width:3;stroke-miterlimit:10"
   cx="461.60001"
   cy="257.29999"
   r="57.099998" />
		<g
   id="XMLID_6847_">
			<defs
   id="defs424">
				<circle
   id="XMLID_6848_"
   cx="461.20001"
   cy="257.10001"
   r="57.200001" />
			</defs>
			<clipPath
   id="XMLID_4481_">
				<use
   xlink:href="#XMLID_6848_"
   style="overflow:visible"
   id="use426"
   x="0"
   y="0"
   width="100%"
   height="100%" />
			</clipPath>
			<g
   id="XMLID_6849_"
   clip-path="url(#XMLID_4481_)">
				<g
   id="XMLID_6850_">
					<ellipse
   id="XMLID_7043_"
   class="st496"
   cx="429.39999"
   cy="269.89999"
   rx="23.1"
   ry="43.400002"
   style="fill:#564a3d" />
					<path
   id="XMLID_7040_"
   class="st925"
   d="m 433.2,226.7 v 12.8 c 8.7,0.5 15.7,13.9 15.7,30.4 0,16.5 -7,29.9 -15.7,30.4 V 313 c 11.7,-2.1 20.9,-20.6 20.9,-43.2 0,-22.5 -9.2,-41 -20.9,-43.1 z"
   inkscape:connector-curvature="0"
   style="fill:#a8947e" />
					<ellipse
   id="XMLID_7037_"
   class="st925"
   cx="432.79999"
   cy="269.89999"
   rx="16.200001"
   ry="30.4"
   style="fill:#a8947e" />
					<linearGradient
   id="XMLID_4568_"
   gradientUnits="userSpaceOnUse"
   x1="432.75491"
   y1="302.81049"
   x2="432.75491"
   y2="242.0186">
						<stop
   offset="0"
   style="stop-color:#564A3D"
   id="stop432" />
						<stop
   offset="1"
   style="stop-color:#31180E"
   id="stop434" />
					</linearGradient>
					<ellipse
   id="XMLID_7036_"
   style="fill:url(#XMLID_4568_)"
   cx="432.79999"
   cy="269.89999"
   rx="16.200001"
   ry="30.4" />
					<rect
   id="XMLID_7033_"
   x="417.10001"
   y="283.20001"
   class="st461"
   width="24.6"
   height="17.9"
   style="fill:#b5ac9c" />
					<path
   id="XMLID_7030_"
   class="st925"
   d="m 433.2,300.2 c -0.2,0 -0.3,0 -0.5,0 -8.9,0 -16.2,-13.6 -16.2,-30.4 0,-16.8 7.2,-30.4 16.2,-30.4 0.2,0 0.3,0 0.5,0 v -12.8 c -0.7,-0.1 -1.5,-0.2 -2.2,-0.2 -12.8,0 -23.1,19.4 -23.1,43.4 0,24 10.3,43.4 23.1,43.4 0.7,0 1.5,-0.1 2.2,-0.2 z"
   inkscape:connector-curvature="0"
   style="fill:#a8947e" />
					<g
   id="XMLID_7023_">
						<ellipse
   id="XMLID_7027_"
   class="st496"
   cx="433.39999"
   cy="233.5"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7024_"
   class="st206"
   cx="433.10001"
   cy="233.5"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7016_">
						<ellipse
   id="XMLID_7020_"
   class="st496"
   cx="412.79999"
   cy="269.89999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7017_"
   class="st206"
   cx="412.5"
   cy="269.89999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7009_">
						<ellipse
   id="XMLID_7013_"
   class="st496"
   cx="416.60001"
   cy="248.39999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7010_"
   class="st206"
   cx="416.20001"
   cy="248.39999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_7002_">
						<ellipse
   id="XMLID_7006_"
   class="st496"
   cx="423.10001"
   cy="238.10001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_7003_"
   class="st206"
   cx="422.79999"
   cy="238.10001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6995_">
						<ellipse
   id="XMLID_6999_"
   class="st496"
   cx="413.39999"
   cy="258.60001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6996_"
   class="st206"
   cx="413.10001"
   cy="258.60001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6988_">
						<ellipse
   id="XMLID_6992_"
   class="st496"
   cx="413.10001"
   cy="279.60001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6989_"
   class="st206"
   cx="412.70001"
   cy="279.60001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6981_">
						<ellipse
   id="XMLID_6985_"
   class="st496"
   cx="421.79999"
   cy="299.10001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6982_"
   class="st206"
   cx="421.5"
   cy="299.10001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6974_">
						<ellipse
   id="XMLID_6978_"
   class="st496"
   cx="442.39999"
   cy="238.10001"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6975_"
   class="st206"
   cx="442.10001"
   cy="238.10001"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6967_">
						<ellipse
   id="XMLID_6971_"
   class="st496"
   cx="447.79999"
   cy="248.39999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6968_"
   class="st206"
   cx="447.5"
   cy="248.39999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6960_">
						<ellipse
   id="XMLID_6964_"
   class="st496"
   cx="416.60001"
   cy="288.79999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6961_"
   class="st206"
   cx="416.20001"
   cy="288.79999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6953_">
						<ellipse
   id="XMLID_6957_"
   class="st496"
   cx="451.89999"
   cy="269.89999"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6954_"
   class="st206"
   cx="451.60001"
   cy="269.89999"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6946_">
						<ellipse
   id="XMLID_6950_"
   class="st496"
   cx="433.39999"
   cy="307"
   rx="1.2"
   ry="2"
   style="fill:#564a3d" />
						<ellipse
   id="XMLID_6947_"
   class="st206"
   cx="433.10001"
   cy="307"
   rx="0.89999998"
   ry="1.5"
   style="fill:#e0cebd" />
					</g>
					<g
   id="XMLID_6929_">
						<ellipse
   id="XMLID_6943_"
   class="st780"
   cx="445.10001"
   cy="292.20001"
   rx="10"
   ry="11.5"
   style="fill:#9e7f66" />
						<ellipse
   id="XMLID_6940_"
   class="st731"
   cx="449.5"
   cy="292.20001"
   rx="7.0999999"
   ry="14.8"
   style="fill:#ffe2ca" />
						<path
   id="XMLID_6937_"
   class="st715"
   d="m 439.5,332.5 c -0.8,0 -1.5,-0.4 -1.9,-1.2 -1.4,-2.9 -13.2,-28.2 -7,-37.4 1.2,-1.7 3.5,-3.7 8,-3.5 1.2,0.1 2,1.1 2,2.2 -0.1,1.2 -1.1,2 -2.2,2 -2.7,-0.2 -3.7,0.8 -4.2,1.6 -3.7,5.5 2.6,23.3 7.3,33.3 0.5,1 0.1,2.3 -1,2.8 -0.4,0.1 -0.7,0.2 -1,0.2 z"
   inkscape:connector-curvature="0"
   style="fill:#605147" />
						<ellipse
   id="XMLID_6934_"
   class="st776"
   cx="450.39999"
   cy="292.20001"
   rx="7.0999999"
   ry="14.8"
   style="fill:#cca885" />
						<linearGradient
   id="XMLID_4575_"
   gradientUnits="userSpaceOnUse"
   x1="450.39841"
   y1="283.93951"
   x2="450.39841"
   y2="301.4119">
							<stop
   offset="0"
   style="stop-color:#564A3D"
   id="stop480" />
							<stop
   offset="1"
   style="stop-color:#31180E"
   id="stop482" />
						</linearGradient>
						<ellipse
   id="XMLID_6933_"
   style="fill:url(#XMLID_4575_)"
   cx="450.39999"
   cy="292.20001"
   rx="3.5"
   ry="8.6000004" />
						<path
   id="XMLID_6930_"
   class="st461"
   d="m 436.4,290.1 c 0,0 1.9,2.4 0,5 h 3.2 c 0,0 1.3,-0.8 1.3,-2.5 0,0 -0.1,-1.9 -1.6,-2.5 z"
   inkscape:connector-curvature="0"
   style="fill:#b5ac9c" />
					</g>
					<g
   id="XMLID_6851_">
						<path
   id="XMLID_6927_"
   class="st724"
   d="m 455.4,259.6 c 0,0 -4.4,-0.9 -5.7,-1.2 -1.3,-0.3 -3.5,-1 -3.5,-1 0,0 -0.3,-0.5 0.2,-0.6 0.5,-0.1 2.6,0.3 2.6,0.3 0,0 -3.5,-0.9 -3.6,-1.2 -0.1,-0.3 0.2,-0.5 0.8,-0.4 0.6,0.1 3.1,0.6 3.1,0.6 0,0 -4.1,-1.1 -4,-1.5 0,-0.4 0.3,-0.7 1.1,-0.4 0.8,0.2 3.1,0.8 3.1,0.8 0,0 -3.2,-1.3 -3.2,-1.5 0,-0.2 -0.3,-0.6 0.4,-0.7 0.6,-0.1 5.5,1.4 5.5,1.4 l -0.5,-0.7 c 0,0 -1.3,-0.5 -1.3,-0.7 0,-0.2 0.1,-0.8 0.9,-0.6 0.8,0.2 3,1.3 3,1.3 l 2.7,1.5 z"
   inkscape:connector-curvature="0"
   style="fill:#ffb236" />
						<g
   id="XMLID_6925_">
							<g
   id="g490">
								<path
   id="XMLID_630_"
   class="st72"
   d="m 478.7,264.7 -1.4,2.9 c -0.8,1.7 -2.8,2.5 -4.5,1.8 -5.3,-2 -12.7,-5.9 -19.5,-9.4 l 3.3,-5.9 c 6.8,3.7 15.5,8.6 22.1,10.6 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
							</g>
						</g>
						<g
   id="XMLID_6923_">
							<g
   id="XMLID_7090_">
								<g
   id="XMLID_7122_">
									<path
   id="XMLID_7123_"
   class="st72"
   d="m 478.3,265.5 -6.7,-0.6 c 6.5,-21.7 8.9,-22.7 9.3,-23.1 l 8.2,1.3 -0.9,2 c 0,0 -9.6,17.4 -9.9,20.4 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
								</g>
							</g>
						</g>
						<path
   id="XMLID_6922_"
   class="st67"
   d="m 505.3,242.2 c 0,0 0.1,2.7 0.4,11 0.6,13.9 0.9,36.2 0,37.2 -1.4,1.5 -27.4,-1 -27.4,-1 0,0 2,-42.2 2.5,-47.4 l 11.3,-3.4 c 0,0 11.1,3.5 13.2,3.6 z"
   inkscape:connector-curvature="0"
   style="fill:#105477" />
						<path
   id="XMLID_6921_"
   class="st319"
   d="m 487.2,241.1 -0.8,-8.9 c 2.9,-1.2 6.4,-3.1 9.4,-2.7 0.4,2.4 0.5,6.5 0.9,9 0.1,0.3 -0.1,-1.1 0.2,1.3 z"
   inkscape:connector-curvature="0"
   style="fill:#e8b897" />
						<polygon
   id="XMLID_6920_"
   class="st67"
   points="505.7,290.5 478.6,289.2 469.5,325.8 469,374.2 474.9,375.5 478.7,327.5 489.2,303.3 491.3,303.3 493.5,327.4 501.3,374.8 507.3,374.6 503.2,325.5 "
   style="fill:#105477" />
						<polygon
   id="XMLID_6917_"
   class="st72"
   points="498.2,242 497,237.2 491.9,241.8 495.1,245.9 "
   style="fill:#106489" />
						<polygon
   id="XMLID_6916_"
   class="st72"
   points="487.4,237.6 485.6,241.7 488.7,245.6 491.9,241.6 "
   style="fill:#106489" />
						<path
   id="XMLID_6915_"
   class="st944"
   d="m 478.1,288.2 c 0,0 15.1,4 28.2,0.4 l -0.2,3.3 c 0,0 -13.5,3.8 -28.6,0 z"
   inkscape:connector-curvature="0"
   style="fill:#444444" />
						<path
   id="XMLID_6914_"
   class="st689"
   d="m 487.9,289.6 1.6,0.2 0.6,-0.4 1.8,0.2 -0.5,4.8 -1.9,-0.2 -0.5,-0.4 -1.6,-0.2 c 0,0 0.1,-2.9 0.5,-4 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_6913_"
   class="st689"
   d="m 495.3,293.8 h -1.6 l -0.5,0.5 h -1.8 l -0.1,-4.8 h 1.9 l 0.5,0.3 h 1.6 c 0,0 0.2,2.8 0,4 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_6912_"
   class="st689"
   d="m 495.9,293.8 c 0,0 0,-2.8 -0.2,-4 l 1.1,-0.1 v 0.6 h -0.5 l 0.3,2.8 h 0.8 v 0.6 c 0,0 -1.2,0.1 -1.5,0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<path
   id="XMLID_6911_"
   class="st689"
   d="m 487.7,289.7 c 0,0 -0.5,2.8 -0.6,3.9 l -1.2,-0.1 v -0.6 h 0.5 l 0.4,-2.7 h -0.5 l 0.1,-0.6 c 0.1,0 0.9,0 1.3,0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
						<g
   id="XMLID_6905_">
							<circle
   id="XMLID_6910_"
   class="st285"
   cx="491.60001"
   cy="248.2"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_6909_"
   class="st285"
   cx="490.89999"
   cy="257.20001"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_6908_"
   class="st285"
   cx="490.10001"
   cy="266.89999"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_6907_"
   class="st285"
   cx="490.10001"
   cy="275.89999"
   r="0.69999999"
   style="fill:#132c33" />
							<circle
   id="XMLID_6906_"
   class="st285"
   cx="490.10001"
   cy="284.89999"
   r="0.69999999"
   style="fill:#132c33" />
						</g>
						<path
   id="XMLID_6904_"
   class="st736"
   d="m 477.8,277.1 c 2.1,0.2 3.6,1.4 2.6,2.6 -0.5,0.6 -1.4,0.9 -2.4,1.1 -0.8,0.2 -1.6,0.1 -2.4,0.3 -2.3,0.5 -2.7,1.3 -3.2,2.4 -0.6,1.3 -1.2,2.7 -3.8,2.9 -3,0.2 -4.4,-1.1 -5.4,-2.5 -2,-2.7 -6.8,-3.6 -9.6,-5.9 -2,-1.6 -2.7,-3.4 -2.3,-5.4 0.7,-3.4 1.8,-6.5 0.8,-10 -0.5,-1.6 -2.7,-4.1 -0.4,-5.5 0.2,-0.1 0.5,0.1 0.3,0.2 -2,1.2 0.4,4.4 0.7,5.9 0.5,2 0.5,4 0.1,6 -0.4,2 -1.6,4.1 -0.9,6.1 0.8,2.2 3.6,3.8 6.6,5.1 1.6,0.7 3.3,1.4 4.4,2.4 0.9,0.9 1.1,1.9 2.4,2.6 2.4,1.4 5.5,0.8 6.5,-1.1 0.5,-1 0.6,-2.2 2.1,-2.9 0.5,-0.3 1.1,-0.4 1.8,-0.5 0.5,-0.1 1.1,-0.1 1.6,-0.2 1.2,0 1.8,-0.5 1.6,-1.5 1.5,-1.1 1.1,-1.7 -1,-1.8 -0.5,-0.1 -0.4,-0.4 -0.1,-0.3 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
						
							<rect
   id="XMLID_6903_"
   x="449.39999"
   y="248.60001"
   transform="matrix(-0.02544872,0.9997,-0.9997,-0.02544872,736.1774,-168.3537)"
   class="st512"
   width="1.5"
   height="52.200001"
   style="fill:#8f9d9e" />
						
							<rect
   id="XMLID_6902_"
   x="474.29999"
   y="267.60001"
   transform="rotate(92.144163,475.41984,275.48245)"
   class="st934"
   width="2.2"
   height="15.7"
   style="fill:#404949" />
						<g
   id="XMLID_6895_">
							
								<rect
   id="XMLID_6901_"
   x="446.20001"
   y="248.89999"
   transform="matrix(-0.7895,0.6137,-0.6137,-0.7895,960.1053,180.8131)"
   class="st926"
   width="5.6999998"
   height="12.3"
   style="fill:#a8a8a8" />
							<circle
   id="XMLID_6900_"
   class="st350"
   cx="447.5"
   cy="252.60001"
   r="1.7"
   style="fill:#b0d882" />
							<g
   id="XMLID_6896_">
								
									<rect
   id="XMLID_6899_"
   x="447.79999"
   y="255.60001"
   transform="matrix(-0.791,0.6118,-0.6118,-0.791,962.5201,183.5123)"
   class="st892"
   width="4.0999999"
   height="1.1"
   style="fill:#707070" />
								
									<rect
   id="XMLID_6898_"
   x="448.79999"
   y="256.89999"
   transform="matrix(-0.7909,0.6119,-0.6119,-0.7909,965.0953,185.1439)"
   class="st892"
   width="4.0999999"
   height="1.1"
   style="fill:#707070" />
								
									<rect
   id="XMLID_6897_"
   x="449.79999"
   y="258.20001"
   transform="matrix(-0.791,0.6118,-0.6118,-0.791,967.6913,186.9236)"
   class="st892"
   width="4.0999999"
   height="1.1"
   style="fill:#707070" />
							</g>
						</g>
						<path
   id="XMLID_6894_"
   class="st724"
   d="m 451.1,252.2 -2,1.5 c 0,0 0.7,1.8 2.8,-0.1"
   inkscape:connector-curvature="0"
   style="fill:#ffb236" />
						<rect
   id="XMLID_6891_"
   x="480.79999"
   y="257.20001"
   class="st931"
   width="6.8000002"
   height="8.5"
   style="fill:#0f4b63" />
						<rect
   id="XMLID_6888_"
   x="494.20001"
   y="257.20001"
   class="st931"
   width="6.8000002"
   height="8.5"
   style="fill:#0f4b63" />
						<polygon
   id="XMLID_6885_"
   class="st72"
   points="488.3,255.3 480.3,255.3 479.4,258.6 488.3,258.6 "
   style="fill:#106489" />
						<polygon
   id="XMLID_6882_"
   class="st72"
   points="502.3,255.3 494.3,255.3 493.4,258.6 502.3,258.6 "
   style="fill:#106489" />
						<g
   id="XMLID_6877_">
							<path
   id="XMLID_6881_"
   class="st72"
   d="m 496.2,268.9 5.7,-26.3 c 8.9,-2.2 5.7,7.7 5.7,7.7 0,0 -4.9,21.5 -6,23.3 -0.1,0.3 -5.4,-4.7 -5.4,-4.7 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
							<g
   id="XMLID_6879_">
								<g
   id="g530">
									<path
   id="XMLID_196_"
   class="st724"
   d="m 475.8,273.6 -1.7,0.4 -3.6,1.5 c -0.3,0 -0.9,0.4 -0.7,0.7 v 0 c 0.1,0.2 0.3,0.5 1.2,0.4 l 1.4,-0.6 c 0,0 0.5,-0.2 -1.7,1.8 -0.2,0.2 -0.6,0.8 -0.1,1 0.5,0.2 2.2,-1 2.2,-1 l 0.1,0.2 -1.7,1.6 c -0.3,0.3 -0.8,0.9 -0.4,1 0.3,0.1 0.9,-0.2 0.9,-0.2 l 1.7,-1.3 0.1,0.2 c 0,0 -1.6,1 -1.4,1.6 0.1,0.4 0.7,0.2 1,0 l 1,-0.9 0.1,0.1 c 0,0 -0.4,0.4 -0.2,0.6 0.2,0.3 0.8,0.1 1,0 1,-0.4 2.5,-2.2 2.5,-2.2 0,0 2.1,-1.7 1.4,-3.2 -0.9,-1.6 -1.3,-1.7 -3.1,-1.7 z"
   inkscape:connector-curvature="0"
   style="fill:#ffb236" />
								</g>
							</g>
							<path
   id="XMLID_6878_"
   class="st72"
   d="m 501.7,273.9 c -8.4,1.9 -24.6,5.1 -24.6,5.1 l -0.9,-6 21.4,-5.1 c 2.2,2.4 4.1,4.1 4.1,6 z"
   inkscape:connector-curvature="0"
   style="fill:#106489" />
						</g>
						<g
   id="XMLID_6852_">
							<path
   id="XMLID_6876_"
   class="st319"
   d="m 477.3,226.2 c -0.7,-0.8 -1.7,-0.6 -2,0.3 -0.2,0.9 0.3,2.1 1.1,2.6 0.8,0.6 1.7,0.7 2.4,0.4"
   inkscape:connector-curvature="0"
   style="fill:#e8b897" />
							<path
   id="XMLID_6875_"
   class="st689"
   d="m 474.5,218.8 c 0,0 5,18.4 11.8,20.1 l 0.3,-0.6 c 0,0 -5,-3.1 -10.4,-19.9 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_6874_"
   class="st530"
   d="m 488.5,239.4 c 2.5,-0.4 2.6,-0.9 3,-1.2 0.6,-0.5 5.4,-8.6 5.3,-9.5 -0.3,-4.4 -0.6,-6.5 -1.6,-10.8 -0.7,-3 -1.6,-6.3 -3.8,-8.2 -2.7,-2.4 -6.5,-2.1 -9.8,-1.5 -1.5,0.3 -3.9,1.1 -5.3,2.5 -1.1,1.2 -1.8,5.1 -1.5,6.3 1.7,7.2 2.8,9.3 5.7,16.2 1.4,3.2 7.4,6.3 8,6.2"
   inkscape:connector-curvature="0"
   style="fill:#f4c4a4" />
							<path
   id="XMLID_6873_"
   class="st205"
   d="m 486.2,222.3 c -3.6,-3.7 2.3,-6.9 4.5,-1.1 0,0 -0.4,0.7 -1.9,1.1 -1.6,0.5 -2.6,0 -2.6,0 z"
   inkscape:connector-curvature="0"
   style="fill:#e0b192" />
							<path
   id="XMLID_6872_"
   class="st205"
   d="m 478,224.3 c -3.6,-3.7 2.3,-6.9 4.5,-1.1 0,0 1,6.1 1,6.4 0.2,1.6 -5.5,-5.3 -5.5,-5.3 z"
   inkscape:connector-curvature="0"
   style="fill:#e0b192" />
							<path
   id="XMLID_6871_"
   class="st319"
   d="m 495.4,221.7 c 0.1,-1.1 1.2,-1.8 2.1,-1.6 1,0.2 1.7,1.3 1.8,2.3 0.1,1.1 -0.3,2.1 -1,2.8 -0.4,0.4 -0.9,0.8 -1.5,0.8 -0.6,0 -1.2,-0.4 -1.4,-1"
   inkscape:connector-curvature="0"
   style="fill:#e8b897" />
							<path
   id="XMLID_6870_"
   class="st495"
   d="m 482.4,222.7 c 0,0 0.2,0.8 0.5,2.1 0.3,1.2 0.6,2.9 0.8,4.5 0.1,0.4 0.1,0.9 0.3,1.1 0.2,0.2 0.5,0.3 0.9,0.3 0.7,-0.1 1.4,-0.3 2,-0.5 0.6,-0.2 1.1,-0.3 1.5,-0.4 0.4,-0.1 0.6,-0.1 0.6,-0.1 0,0 -0.2,0.1 -0.5,0.2 -0.3,0.1 -0.8,0.3 -1.4,0.6 -0.6,0.2 -1.3,0.5 -2.1,0.7 -0.4,0.1 -1,0.1 -1.3,-0.4 -0.3,-0.4 -0.3,-0.9 -0.4,-1.3 -0.3,-1.7 -0.5,-3.3 -0.6,-4.6 -0.2,-1.3 -0.3,-2.2 -0.3,-2.2 z"
   inkscape:connector-curvature="0"
   style="fill:#56361a" />
							<path
   id="XMLID_6869_"
   class="st689"
   d="m 489.5,232.5 c 0,0.5 -0.2,1.4 -1.9,1.9 -1.9,0.6 -2.4,-0.3 -2.7,-0.8 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_6868_"
   class="st689"
   d="m 489,218.8 c 0,0 -0.3,-0.2 -0.8,-0.3 -0.2,-0.1 -0.5,-0.2 -0.8,-0.2 -0.3,-0.1 -0.6,-0.1 -0.8,-0.1 0,0 -0.1,0 -0.1,0 h -0.1 c -0.1,0 -0.1,0 -0.2,0.1 -0.1,0.1 -0.3,0.1 -0.4,0.2 -0.3,0.1 -0.5,0.3 -0.7,0.4 -0.4,0.3 -0.7,0.5 -0.7,0.5 0,0 0,-0.4 0.3,-0.9 0.1,-0.2 0.4,-0.5 0.7,-0.7 0.1,-0.1 0.3,-0.2 0.5,-0.3 0.1,0 0.2,-0.1 0.3,-0.1 0.1,0 0.2,-0.1 0.3,-0.1 0.5,-0.1 0.9,0.1 1.2,0.2 0.3,0.2 0.6,0.3 0.8,0.5 0.2,0.2 0.3,0.4 0.4,0.5 0.1,0.2 0.1,0.3 0.1,0.3 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_6867_"
   class="st689"
   d="m 480.8,220.5 c 0,0 -0.4,-0.1 -0.8,-0.1 -0.2,0 -0.5,-0.1 -0.8,-0.1 -0.3,0 -0.6,0 -0.8,0.1 0,0 -0.1,0 -0.1,0 l -0.1,0.1 c -0.1,0 -0.1,0.1 -0.2,0.1 -0.1,0.1 -0.2,0.1 -0.4,0.2 -0.2,0.2 -0.4,0.4 -0.6,0.5 -0.3,0.3 -0.6,0.6 -0.6,0.6 0,0 -0.1,-0.4 0.1,-0.9 0.1,-0.3 0.3,-0.6 0.5,-0.8 0.1,-0.1 0.2,-0.3 0.4,-0.4 0.1,-0.1 0.2,-0.1 0.3,-0.2 0.1,0 0.2,-0.1 0.3,-0.1 0.4,-0.2 0.9,-0.1 1.2,0 0.3,0.1 0.6,0.2 0.9,0.4 0.2,0.1 0.4,0.3 0.5,0.4 0.2,0.2 0.2,0.2 0.2,0.2 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_6866_"
   class="st492"
   d="M 496.9,219.8"
   inkscape:connector-curvature="0"
   style="fill:none;stroke:#ffffff;stroke-miterlimit:10" />
							<path
   id="XMLID_6865_"
   class="st736"
   d="m 486.2,222.3 c 0.1,-0.9 2.7,-2.3 4.5,-1.1 0,0 -0.4,0.7 -1.9,1.1 -1.6,0.5 -2.6,0 -2.6,0 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
							
								<ellipse
   id="XMLID_6864_"
   transform="matrix(-0.9713,0.238,-0.238,-0.9713,1014.2476,321.0394)"
   class="st689"
   cx="487.70001"
   cy="221.7"
   rx="1"
   ry="0.80000001"
   style="fill:#2b2b2b" />
							
								<ellipse
   id="XMLID_6863_"
   transform="matrix(-0.9712,0.2381,-0.2381,-0.9712,1012.5817,321.131)"
   class="st736"
   cx="486.89999"
   cy="221.7"
   rx="0.40000001"
   ry="0.30000001"
   style="fill:#ffffff" />
							<path
   id="XMLID_6862_"
   class="st689"
   d="m 492.9,215.4 c 0,0 5.2,15.9 -1.4,22.8 0,0 8.2,-4.7 3.5,-22.6 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<path
   id="XMLID_6861_"
   class="st736"
   d="m 478.3,224.3 c 0.1,-0.9 2.2,-2.2 3.7,-0.9 0,0 -0.3,0.7 -1.6,1 -1.3,0.3 -2.1,-0.1 -2.1,-0.1 z"
   inkscape:connector-curvature="0"
   style="fill:#ffffff" />
							
								<circle
   id="XMLID_6860_"
   transform="matrix(-0.9714,0.2376,-0.2376,-0.9714,998.2216,327.2379)"
   class="st689"
   cx="479.39999"
   cy="223.8"
   r="0.80000001"
   style="fill:#2b2b2b" />
							
								<ellipse
   id="XMLID_6859_"
   transform="matrix(-0.9712,0.2381,-0.2381,-0.9712,996.8858,327.0444)"
   class="st736"
   cx="478.70001"
   cy="223.7"
   rx="0.40000001"
   ry="0.30000001"
   style="fill:#ffffff" />
							<path
   id="XMLID_6858_"
   class="st689"
   d="m 486.3,238.9 c 0,0 0.9,-1.9 6.1,-1.3 0,0 -0.6,1.5 -3,2.1 -2.4,0.5 -3.4,-0.4 -3.1,-0.8 z"
   inkscape:connector-curvature="0"
   style="fill:#2b2b2b" />
							<polygon
   id="XMLID_6857_"
   class="st781"
   points="496.3,216.2 492.1,216.7 493,220.6 496.8,218.8 "
   style="fill:#303233" />
							<polygon
   id="XMLID_6856_"
   class="st781"
   points="496.9,228.7 494.2,230.9 493.7,226.8 497.1,226.7 "
   style="fill:#303233" />
							<path
   id="XMLID_6855_"
   class="st469"
   d="m 473.1,218 c 0,0 -1,-8.7 1.6,-10.7 v -1.8 c 0,0 6.7,-3.2 14.1,-2 7.4,1.3 8.1,10.8 8.1,10.8 z"
   inkscape:connector-curvature="0"
   style="fill:#eaeaea" />
							<polygon
   id="XMLID_6854_"
   class="st778"
   points="472.2,216.9 496.8,213.4 496.8,215.3 473.1,219.3 "
   style="fill:#cccccc" />
							<path
   id="XMLID_6853_"
   class="st941"
   d="m 498,219.4 -7.3,-0.2 -6.8,2 c 0,0 -0.7,2.6 -2.2,0.8 l -6.3,2 1.6,3.4 5.8,-1.7 c 0,0 -0.3,-2.9 0.2,-2.6 0.5,0.3 1.6,2 1.6,2 l 7.9,-2 0.7,-2.4 5,-0.7 z"
   inkscape:connector-curvature="0"
   style="opacity:0.51000001;fill:#ffffff;enable-background:new" />
						</g>
					</g>
				</g>
			</g>
		</g>
		<linearGradient
   id="XMLID_4585_"
   gradientUnits="userSpaceOnUse"
   x1="403.00391"
   y1="257.31149"
   x2="520.16803"
   y2="257.31149">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop564" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop566" />
		</linearGradient>
		
			<circle
   id="XMLID_5750_"
   style="fill:none;stroke:url(#XMLID_4585_);stroke-width:3;stroke-miterlimit:10"
   cx="461.60001"
   cy="257.29999"
   r="57.099998" />
	</g>
	<g
   id="img7"
   :class="[{'': vistos[6]} ]" @click="darVisto(6)"
   inkscape:label="#XMLID_7388_">
		<linearGradient
   id="XMLID_4590_"
   gradientUnits="userSpaceOnUse"
   x1="485.19241"
   y1="95.430702"
   x2="602.35742"
   y2="95.430702">
			<stop
   offset="0"
   style="stop-color:#23CAD9"
   id="stop571" />
			<stop
   offset="0.9898"
   style="stop-color:#32ADF0"
   id="stop573" />
		</linearGradient>
		
			<circle
   id="XMLID_2350_"
   style="fill:#ffffff;stroke:url(#XMLID_4590_);stroke-width:3;stroke-miterlimit:10"
   cx="543.79999"
   cy="95.400002"
   r="57.099998" />
		<g
   id="XMLID_7096_">
			<linearGradient
   id="XMLID_4592_"
   gradientUnits="userSpaceOnUse"
   x1="545.05469"
   y1="49.9482"
   x2="545.05469"
   y2="140.5724">
				<stop
   offset="0"
   style="stop-color:#FFE888"
   id="stop577" />
				<stop
   offset="0.9789"
   style="stop-color:#FFA370"
   id="stop579" />
			</linearGradient>
			<rect
   id="XMLID_7271_"
   x="512.70001"
   y="56.799999"
   class="st354"
   width="64.699997"
   height="81.5"
   style="fill:url(#XMLID_4592_)" />
			<rect
   id="XMLID_7268_"
   x="517.70001"
   y="62.5"
   class="st736"
   width="54.799999"
   height="70.900002"
   style="fill:#ffffff" />
			<rect
   id="XMLID_7267_"
   x="527"
   y="54.5"
   class="st641"
   width="36"
   height="12.8"
   style="fill:#939fa3" />
			<circle
   id="XMLID_7266_"
   class="st641"
   cx="545.09998"
   cy="55.599998"
   r="6.5999999"
   style="fill:#939fa3" />
			<rect
   id="XMLID_7232_"
   x="524.70001"
   y="92.800003"
   class="st295"
   width="40.700001"
   height="31.5"
   style="fill:#e2e2e2" />
			<rect
   id="XMLID_7231_"
   x="524.70001"
   y="84.800003"
   class="st712"
   width="40.700001"
   height="6"
   style="fill:#c9c9c9" />
			<g
   id="XMLID_7124_">
				<path
   id="XMLID_7227_"
   d="m 524.6,82.2 v -4.8 h 1.6 c 0.2,0 0.5,0 0.7,0.1 0.2,0 0.4,0.1 0.6,0.2 0.2,0.1 0.3,0.3 0.4,0.4 0.1,0.1 0.1,0.4 0.1,0.7 0,0.4 -0.1,0.7 -0.3,0.9 -0.2,0.2 -0.4,0.4 -0.7,0.5 l 1.1,2 h -0.9 l -1,-1.9 h -0.7 v 1.9 z m 0.9,-2.5 h 0.7 c 0.3,0 0.6,-0.1 0.7,-0.2 0.2,-0.1 0.3,-0.3 0.3,-0.6 0,-0.3 -0.1,-0.5 -0.3,-0.6 -0.2,-0.1 -0.4,-0.2 -0.7,-0.2 h -0.7 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7230_"
   d="m 528.9,82.2 v -4.8 h 2.9 v 0.7 h -2 v 1.2 h 1.7 V 80 h -1.7 v 1.4 h 2.1 v 0.7 h -3 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7235_"
   d="m 534.3,82.3 c -0.3,0 -0.6,-0.1 -0.9,-0.2 -0.3,-0.1 -0.6,-0.3 -0.8,-0.5 L 533,81 c 0.2,0.2 0.4,0.3 0.6,0.4 0.2,0.1 0.4,0.1 0.7,0.1 0.3,0 0.5,-0.1 0.6,-0.2 0.1,-0.1 0.2,-0.3 0.2,-0.4 0,-0.1 0,-0.2 -0.1,-0.2 0,-0.1 -0.1,-0.1 -0.2,-0.2 -0.1,-0.1 -0.1,-0.1 -0.2,-0.1 -0.1,0 -0.2,-0.1 -0.3,-0.1 L 533.6,80 c -0.1,0 -0.2,-0.1 -0.3,-0.2 -0.1,-0.1 -0.2,-0.2 -0.3,-0.3 -0.1,-0.1 -0.2,-0.2 -0.2,-0.4 -0.1,-0.1 -0.1,-0.3 -0.1,-0.5 0,-0.2 0,-0.4 0.1,-0.5 0.1,-0.2 0.2,-0.3 0.3,-0.4 0.1,-0.1 0.3,-0.2 0.5,-0.3 0.2,-0.1 0.4,-0.1 0.6,-0.1 0.3,0 0.5,0.1 0.8,0.2 0.3,0.1 0.5,0.3 0.7,0.4 l -0.4,0.5 c -0.2,-0.1 -0.3,-0.2 -0.5,-0.3 -0.2,-0.1 -0.4,-0.1 -0.6,-0.1 -0.2,0 -0.4,0 -0.5,0.1 -0.1,0.1 -0.2,0.2 -0.2,0.4 0,0.1 0,0.2 0.1,0.2 0,0.1 0.1,0.1 0.2,0.2 0.1,0.1 0.2,0.1 0.2,0.1 0.1,0 0.2,0.1 0.3,0.1 l 0.6,0.3 c 0.1,0.1 0.3,0.1 0.4,0.2 0.1,0.1 0.2,0.2 0.3,0.3 0.1,0.1 0.2,0.2 0.2,0.4 0,0.2 0.1,0.3 0.1,0.5 0,0.2 0,0.4 -0.1,0.5 -0.1,0.2 -0.2,0.3 -0.3,0.4 -0.1,0.1 -0.3,0.2 -0.5,0.3 -0.2,0.3 -0.5,0.3 -0.7,0.3 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7239_"
   d="m 538.6,82.3 c -0.3,0 -0.5,0 -0.7,-0.1 -0.2,-0.1 -0.4,-0.2 -0.6,-0.4 -0.2,-0.2 -0.3,-0.4 -0.4,-0.7 -0.1,-0.3 -0.1,-0.6 -0.1,-1 v -2.7 h 0.8 v 2.7 c 0,0.3 0,0.5 0.1,0.7 0.1,0.2 0.1,0.3 0.2,0.4 0.1,0.1 0.2,0.2 0.3,0.2 0.1,0 0.2,0.1 0.4,0.1 0.1,0 0.3,0 0.4,-0.1 0.1,0 0.2,-0.1 0.3,-0.2 0.1,-0.1 0.2,-0.2 0.2,-0.4 0,-0.2 0.1,-0.4 0.1,-0.7 v -2.7 h 0.8 v 2.7 c 0,0.4 0,0.7 -0.1,1 -0.1,0.3 -0.2,0.5 -0.4,0.7 -0.2,0.2 -0.3,0.3 -0.6,0.4 -0.3,0.1 -0.4,0.1 -0.7,0.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7241_"
   d="m 541.6,82.2 v -4.8 h 0.8 v 4.1 h 2 v 0.7 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7246_"
   d="M 545.4,82.2 V 78.1 H 544 v -0.7 h 3.6 v 0.7 h -1.4 v 4.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7248_"
   d="m 547.5,82.2 1.6,-4.8 h 1 l 1.6,4.8 h -0.9 l -0.4,-1.3 h -1.6 l -0.4,1.3 z m 1.6,-2.5 -0.2,0.6 h 1.2 l -0.2,-0.6 c -0.1,-0.3 -0.2,-0.5 -0.2,-0.8 0,-0.3 -0.1,-0.5 -0.2,-0.8 v 0 c -0.1,0.3 -0.1,0.5 -0.2,0.8 -0.1,0.3 -0.1,0.5 -0.2,0.8 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7251_"
   d="m 552.2,82.2 v -4.8 h 1.3 c 0.7,0 1.3,0.2 1.7,0.6 0.4,0.4 0.6,1 0.6,1.8 0,0.4 -0.1,0.7 -0.2,1 -0.1,0.3 -0.3,0.6 -0.5,0.8 -0.2,0.2 -0.4,0.4 -0.7,0.5 -0.3,0.1 -0.6,0.2 -1,0.2 h -1.2 z m 0.8,-0.7 h 0.4 c 0.5,0 0.9,-0.1 1.1,-0.4 0.3,-0.3 0.4,-0.7 0.4,-1.3 0,-0.6 -0.1,-1 -0.4,-1.3 -0.3,-0.3 -0.6,-0.4 -1.1,-0.4 H 553 Z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7254_"
   d="m 558.6,82.3 c -0.3,0 -0.6,-0.1 -0.9,-0.2 -0.3,-0.1 -0.5,-0.3 -0.7,-0.5 -0.2,-0.2 -0.3,-0.5 -0.4,-0.8 -0.1,-0.3 -0.2,-0.7 -0.2,-1 0,-0.4 0.1,-0.7 0.2,-1 0.1,-0.3 0.2,-0.6 0.4,-0.8 0.2,-0.2 0.4,-0.4 0.7,-0.5 0.3,-0.1 0.5,-0.2 0.9,-0.2 0.4,0 0.6,0.1 0.9,0.2 0.3,0.1 0.5,0.3 0.7,0.5 0.2,0.2 0.3,0.5 0.4,0.8 0.1,0.3 0.2,0.6 0.2,1 0,0.4 -0.1,0.7 -0.2,1 -0.1,0.3 -0.2,0.6 -0.4,0.8 -0.2,0.2 -0.4,0.4 -0.7,0.5 -0.3,0.1 -0.6,0.2 -0.9,0.2 z m 0,-0.7 c 0.2,0 0.4,0 0.5,-0.1 0.2,-0.1 0.3,-0.2 0.4,-0.4 0.1,-0.2 0.2,-0.3 0.2,-0.6 0,-0.3 0.1,-0.5 0.1,-0.7 0,-0.5 -0.1,-1 -0.3,-1.3 -0.2,-0.3 -0.5,-0.5 -0.9,-0.5 -0.4,0 -0.7,0.2 -0.9,0.5 -0.2,0.3 -0.3,0.7 -0.3,1.3 0,0.3 0,0.5 0.1,0.7 0.1,0.2 0.1,0.4 0.2,0.6 0.1,0.2 0.2,0.3 0.4,0.4 0.1,0 0.3,0.1 0.5,0.1 z"
   inkscape:connector-curvature="0" />
				<path
   id="XMLID_7257_"
   d="m 563,82.3 c -0.3,0 -0.6,-0.1 -0.9,-0.2 -0.3,-0.1 -0.6,-0.3 -0.8,-0.5 l 0.5,-0.6 c 0.2,0.2 0.4,0.3 0.6,0.4 0.2,0.1 0.4,0.1 0.7,0.1 0.3,0 0.5,-0.1 0.6,-0.2 0.1,-0.1 0.2,-0.3 0.2,-0.4 0,-0.1 0,-0.2 -0.1,-0.2 -0.1,0 -0.1,-0.1 -0.2,-0.2 -0.1,-0.1 -0.1,-0.1 -0.2,-0.1 -0.1,0 -0.2,-0.1 -0.3,-0.1 L 562.4,80 c -0.1,0 -0.2,-0.1 -0.3,-0.2 -0.1,-0.1 -0.2,-0.2 -0.3,-0.3 -0.1,-0.1 -0.2,-0.2 -0.2,-0.4 -0.1,-0.1 -0.1,-0.3 -0.1,-0.5 0,-0.2 0,-0.4 0.1,-0.5 0.1,-0.1 0.2,-0.3 0.3,-0.4 0.1,-0.1 0.3,-0.2 0.5,-0.3 0.2,-0.1 0.4,-0.1 0.6,-0.1 0.3,0 0.5,0.1 0.8,0.2 0.3,0.1 0.5,0.3 0.7,0.4 l -0.4,0.5 c -0.2,-0.1 -0.3,-0.2 -0.5,-0.3 C 563.4,78 563.2,78 563,78 c -0.2,0 -0.4,0 -0.5,0.1 -0.1,0.1 -0.2,0.2 -0.2,0.4 0,0.1 0,0.2 0.1,0.2 0,0.1 0.1,0.1 0.2,0.2 0.1,0.1 0.2,0.1 0.2,0.1 0.1,0 0.2,0.1 0.3,0.1 l 0.6,0.3 c 0.1,0.1 0.3,0.1 0.4,0.2 0.1,0.1 0.2,0.2 0.3,0.3 0.1,0.1 0.2,0.2 0.2,0.4 0,0.1 0.1,0.3 0.1,0.5 0,0.2 0,0.4 -0.1,0.5 -0.1,0.2 -0.2,0.3 -0.3,0.4 -0.1,0.1 -0.3,0.2 -0.5,0.3 -0.2,0.3 -0.5,0.3 -0.8,0.3 z"
   inkscape:connector-curvature="0" />
			</g>
		</g>
	</g>
	<g
   id="num1"
   inkscape:label="#XMLID_4741_">
		<circle
   id="XMLID_784_"
   class="st866"
   cx="81.599998"
   cy="36.799999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_194_">
			<rect
   id="XMLID_450_"
   x="74.400002"
   y="29.299999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(76.4414,43.3926)"
   class="st736 st692 st939"
   id="text603"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">1</text>

		</g>
	</g>
	<g
   id="XMLID_6100_">
		<circle
   id="XMLID_6132_"
   class="st866"
   cx="210"
   cy="36.799999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_6103_">
			<rect
   id="XMLID_432_"
   x="202.8"
   y="29.299999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(204.9082,43.3926)"
   class="st736 st692 st939"
   id="text609"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">3</text>

		</g>
	</g>
	<g
   id="XMLID_6104_">
		<circle
   id="XMLID_6498_"
   class="st866"
   cx="374.89999"
   cy="36.799999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_6113_">
			<rect
   id="XMLID_430_"
   x="367.70001"
   y="29.299999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(369.7988,43.3926)"
   class="st736 st692 st939"
   id="text615"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">5</text>

		</g>
	</g>
	<g
   id="XMLID_6127_">
		<circle
   id="XMLID_6516_"
   class="st866"
   cx="544.20001"
   cy="36.799999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_6490_">
			<rect
   id="XMLID_429_"
   x="537"
   y="29.299999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(539.0625,43.3926)"
   class="st736 st692 st939"
   id="text621"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">7</text>

		</g>
	</g>
	<g
   id="XMLID_4927_">
		<circle
   id="XMLID_6106_"
   class="st866"
   cx="123.1"
   cy="315.39999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_5005_">
			<rect
   id="XMLID_427_"
   x="115.9"
   y="307.89999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(117.9531,322.0244)"
   class="st736 st692 st939"
   id="text627"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">2</text>

		</g>
	</g>
	<g
   id="XMLID_6493_">
		<circle
   id="XMLID_6845_"
   class="st866"
   cx="292.70001"
   cy="315.39999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_6506_">
			<rect
   id="XMLID_426_"
   x="285.5"
   y="307.89999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(287.5898,322.0244)"
   class="st736 st692 st939"
   id="text633"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">4</text>

		</g>
	</g>
	<g
   id="XMLID_6496_">
		<circle
   id="XMLID_6562_"
   class="st866"
   cx="461.29999"
   cy="315.39999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_6513_">
			<rect
   id="XMLID_424_"
   x="454.10001"
   y="307.89999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(456.1855,322.0244)"
   class="st736 st692 st939"
   id="text639"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">6</text>

		</g>
	</g>
	<g
   inkscape:label="#XMLID_4180_">
		<circle
   id="XMLID_5657_"
   class="st866"
   cx="587.09998"
   cy="315.39999"
   r="11.5"
   style="fill:#042ab2" />
		<g
   id="XMLID_4245_">
			<rect
   id="XMLID_423_"
   x="579.90002"
   y="307.89999"
   class="st745"
   width="14.4"
   height="15"
   style="fill:none" />
			<text
   transform="translate(581.9824,322.0244)"
   class="st736 st692 st939"
   id="text645"
   style="font-size:20.03310013px;font-family:FontBase-Regular;fill:#ffffff">8</text>

		</g>
	</g>
	<g
   id="check0"
   class="oculto"
   inkscape:label="#XMLID_68_">
		
			<linearGradient
   id="XMLID_4594_"
   gradientUnits="userSpaceOnUse"
   x1="80.988297"
   y1="-17314.145"
   x2="80.988297"
   y2="-17283.1"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop649" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop651" />
		</linearGradient>
		<path
   id="XMLID_72_"
   class="st355"
   d="m 81,164.6 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4594_)" />
		<polygon
   id="XMLID_71_"
   class="st736"
   points="76.4,152.4 78.8,154.6 85.4,146.9 87.9,149.1 79.1,159.4 74.2,154.8 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check1"
   class="oculto"
   inkscape:label="#XMLID_1059_">
		
			<linearGradient
   id="XMLID_4597_"
   gradientUnits="userSpaceOnUse"
   x1="123.0918"
   y1="-17359.859"
   x2="123.0918"
   y2="-17328.814"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop657" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop659" />
		</linearGradient>
		<path
   id="XMLID_1065_"
   class="st356"
   d="m 123.1,210.3 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4597_)" />
		<polygon
   id="XMLID_1060_"
   class="st736"
   points="118.5,198.1 120.9,200.3 127.5,192.7 130,194.8 121.2,205.1 116.3,200.5 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check3"
   class="oculto"
   inkscape:label="#XMLID_1662_">
		
			<linearGradient
   id="XMLID_4600_"
   gradientUnits="userSpaceOnUse"
   x1="292.918"
   y1="-17359.859"
   x2="292.918"
   y2="-17328.814"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop665" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop667" />
		</linearGradient>
		<path
   id="XMLID_4193_"
   class="st359"
   d="m 292.9,210.3 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4600_)" />
		<polygon
   id="XMLID_1666_"
   class="st736"
   points="288.4,198.1 290.8,200.3 297.4,192.7 299.9,194.8 291,205.1 286.1,200.5 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check5"
   class="oculto"
   inkscape:label="#XMLID_4228_">
		
			<linearGradient
   id="XMLID_4601_"
   gradientUnits="userSpaceOnUse"
   x1="461.58591"
   y1="-17359.859"
   x2="461.58591"
   y2="-17328.814"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop673" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop675" />
		</linearGradient>
		<path
   id="XMLID_4232_"
   class="st360"
   d="m 461.6,210.3 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4601_)" />
		<polygon
   id="XMLID_4231_"
   class="st736"
   points="457,198.1 459.4,200.3 466,192.7 468.5,194.8 459.7,205.1 454.8,200.5 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check7"
   class="oculto"
    inkscape:label="XMLID_4235_">
		
			<linearGradient
   id="XMLID_4602_"
   gradientUnits="userSpaceOnUse"
   x1="586.38672"
   y1="-17359.859"
   x2="586.38672"
   y2="-17328.814"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop681" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop683" />
		</linearGradient>
		<path
   id="XMLID_4238_"
   class="st361"
   d="m 586.4,210.3 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.5,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4602_)" />
		<polygon
   id="XMLID_4237_"
   class="st736"
   points="581.8,198.1 584.2,200.3 590.8,192.7 593.3,194.8 584.5,205.1 579.6,200.5 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check2"
   class="oculto"
   inkscape:label="#XMLID_83_">
		
			<linearGradient
   id="XMLID_4603_"
   gradientUnits="userSpaceOnUse"
   x1="210.04691"
   y1="-17314.145"
   x2="210.04691"
   y2="-17283.1"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop689" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop691" />
		</linearGradient>
		<path
   id="XMLID_238_"
   class="st362"
   d="m 210,164.6 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4603_)" />
		<polygon
   id="XMLID_229_"
   class="st736"
   points="205.5,152.4 207.9,154.6 214.5,146.9 217,149.1 208.2,159.4 203.2,154.8 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check4"
   class="oculto"
   inkscape:label="#XMLID_703_">
		
			<linearGradient
   id="XMLID_4604_"
   gradientUnits="userSpaceOnUse"
   x1="378.41019"
   y1="-17314.801"
   x2="378.41019"
   y2="-17283.756"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop697" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop699" />
		</linearGradient>
		<path
   id="XMLID_705_"
   class="st363"
   d="m 378.4,165.2 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4604_)" />
		<polygon
   id="XMLID_704_"
   class="st736"
   points="373.8,153 376.3,155.3 382.8,147.6 385.4,149.8 376.5,160.1 371.6,155.4 "
   style="fill:#ffffff" />
	</g>
	<g
   id="check6"
   class="oculto"
   inkscape:label="#XMLID_709_">
		
			<linearGradient
   id="XMLID_4606_"
   gradientUnits="userSpaceOnUse"
   x1="549.5293"
   y1="-17314.145"
   x2="549.5293"
   y2="-17283.1"
   gradientTransform="matrix(1,0,0,-1,0,-17146.143)">
			<stop
   offset="0"
   style="stop-color:#54D354"
   id="stop705" />
			<stop
   offset="1"
   style="stop-color:#119552"
   id="stop707" />
		</linearGradient>
		<path
   id="XMLID_1057_"
   class="st364"
   d="m 549.5,164.6 c -6.7,0 -12.1,-5.4 -12.1,-12.1 0,-6.7 5.4,-12.1 12.1,-12.1 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 z"
   inkscape:connector-curvature="0"
   style="fill:url(#XMLID_4606_)" />
		<polygon
   id="XMLID_710_"
   class="st736"
   points="545,152.4 547.4,154.6 554,146.9 556.5,149.1 547.6,159.4 542.7,154.8 "
   style="fill:#ffffff" />
	</g>
</g>
</svg>
</template>
<script>
export default {
  data(){
    return{
      contador:0,
      vistos: Array(8).fill(false)
    }
  },
    methods:{
    darVisto(num){
      this.$emit('contenido',num)
      this.$set(this.vistos, num, true)
      let todosVistos = this.vistos.every((el) => {
        return el;
      });
      if(todosVistos){
        this.$store.commit("nextShow", true);
      }
      this.contador= num+1
      document.getElementById('check'+num).classList.remove('oculto')
      console.log(num+'numero')
    },
  }
}
</script>
<style lang="scss" scoped>
	.st0{fill:none;stroke:url(#XMLID_7513_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st1{fill:#46535B;}
	.st2{fill:#FFFFFF;stroke:url(#XMLID_6213_);stroke-width:0.25;stroke-miterlimit:10;}
	.st3{fill:url(#XMLID_4925_);stroke:#383838;stroke-miterlimit:10;}
	.st4{fill:#AAAAAA;}
	.st5{fill:none;stroke:url(#XMLID_4354_);stroke-width:6;stroke-miterlimit:10;}
	.st6{fill:url(#XMLID_7039_);}
	.st7{fill:url(#XMLID_7054_);}
	.st8{fill:url(#XMLID_7067_);}
	.st9{fill:url(#XMLID_7068_);}
	.st10{fill:url(#XMLID_7069_);}
	.st11{fill:url(#XMLID_7070_);}
	.st12{fill:url(#XMLID_7072_);}
	.st13{fill:url(#XMLID_7073_);}
	.st14{fill:url(#XMLID_7092_);}
	.st15{fill:url(#XMLID_7093_);}
	.st16{fill:none;stroke:url(#XMLID_7224_);stroke-width:4;stroke-miterlimit:10;}
	.st17{fill:#7C9DA5;}
	.st18{fill:#ABBFC6;}
	.st19{fill:none;stroke:url(#XMLID_7225_);stroke-width:4;stroke-miterlimit:10;}
	.st20{fill:url(#XMLID_7144_);}
	.st21{fill:#49493A;}
	.st22{fill:url(#XMLID_7186_);}
	.st23{fill:url(#XMLID_7195_);}
	.st24{fill:url(#XMLID_7196_);}
	.st25{fill:url(#XMLID_7199_);}
	.st26{fill:#AC7B63;}
	.st27{fill:url(#XMLID_6492_);stroke:#444444;stroke-miterlimit:10;}
	.st28{fill:url(#XMLID_7200_);}
	.st29{fill:url(#XMLID_7202_);}
	.st30{fill:url(#XMLID_7203_);}
	.st31{fill:url(#XMLID_7206_);}
	.st32{fill:url(#XMLID_7209_);}
	.st33{fill:url(#XMLID_7222_);}
	.st34{fill:url(#XMLID_7223_);}
	.st35{fill:url(#XMLID_7226_);}
	.st36{fill:url(#XMLID_7234_);}
	.st37{fill:url(#XMLID_7236_);}
	.st38{fill:url(#XMLID_7238_);}
	.st39{fill:url(#XMLID_7242_);}
	.st40{fill:url(#XMLID_7243_);}
	.st41{fill:url(#XMLID_7244_);}
	.st42{fill:url(#XMLID_7259_);}
	.st43{fill:url(#XMLID_7262_);}
	.st44{fill:url(#XMLID_7265_);}
	.st45{fill:url(#XMLID_7269_);}
	.st46{fill:url(#XMLID_7275_);}
	.st47{fill:url(#XMLID_7276_);}
	.st48{fill:url(#XMLID_7278_);}
	.st49{fill:url(#XMLID_7279_);}
	.st50{fill:url(#XMLID_7281_);}
	.st51{fill:url(#XMLID_7282_);}
	.st52{fill:url(#XMLID_7285_);}
	.st53{fill:url(#XMLID_7286_);}
	.st54{fill:url(#XMLID_7288_);}
	.st55{fill:url(#XMLID_7289_);}
	.st56{fill:url(#XMLID_7291_);}
	.st57{fill:url(#XMLID_7292_);}
	.st58{fill:url(#XMLID_7294_);}
	.st59{fill:url(#XMLID_7295_);}
	.st60{fill:url(#XMLID_7297_);}
	.st61{fill:url(#XMLID_7298_);}
	.st62{fill:#ADAC9C;}
	.st63{fill:#ADD86F;}
	.st64{fill:url(#XMLID_7301_);}
	.st65{fill:url(#XMLID_7302_);}
	.st66{fill:url(#XMLID_7304_);}
	.st67{fill:#105477;}
	.st68{fill:url(#XMLID_7311_);}
	.st69{fill:url(#XMLID_7316_);}
	.st70{fill:url(#XMLID_7317_);}
	.st71{fill:url(#XMLID_7319_);}
	.st72{fill:#106489;}
	.st73{fill:url(#XMLID_7320_);}
	.st74{fill:url(#XMLID_7322_);}
	.st75{fill:url(#XMLID_7326_);}
	.st76{fill:url(#XMLID_7328_);}
	.st77{fill:url(#XMLID_7333_);}
	.st78{fill:url(#XMLID_7336_);}
	.st79{fill:url(#XMLID_7337_);}
	.st80{fill:url(#XMLID_7338_);}
	.st81{fill:url(#XMLID_7339_);}
	.st82{fill:url(#XMLID_7340_);}
	.st83{fill:url(#XMLID_7341_);}
	.st84{fill:url(#XMLID_7342_);}
	.st85{fill:url(#XMLID_7343_);}
	.st86{fill:url(#XMLID_7344_);}
	.st87{fill:url(#XMLID_7346_);}
	.st88{fill:url(#XMLID_7348_);}
	.st89{fill:url(#XMLID_7349_);}
	.st90{fill:url(#XMLID_7350_);}
	.st91{fill:url(#XMLID_7351_);}
	.st92{fill:url(#XMLID_7352_);}
	.st93{fill:url(#XMLID_7353_);}
	.st94{fill:url(#XMLID_7354_);}
	.st95{fill:url(#XMLID_7356_);}
	.st96{fill:url(#XMLID_7358_);}
	.st97{fill:url(#XMLID_7359_);}
	.st98{fill:url(#XMLID_7360_);}
	.st99{fill:url(#XMLID_7361_);}
	.st100{fill:url(#XMLID_7362_);}
	.st101{fill:url(#XMLID_7363_);}
	.st102{fill:url(#XMLID_7364_);}
	.st103{fill:url(#XMLID_7365_);}
	.st104{fill:url(#XMLID_7366_);}
	.st105{fill:url(#XMLID_7367_);}
	.st106{fill:url(#XMLID_7368_);}
	.st107{fill:url(#XMLID_7369_);}
	.st108{fill:url(#XMLID_7370_);}
	.st109{fill:url(#XMLID_7371_);}
	.st110{fill:url(#XMLID_7372_);}
	.st111{fill:url(#XMLID_7373_);}
	.st112{fill:url(#XMLID_7374_);}
	.st113{fill:url(#XMLID_7377_);}
	.st114{fill:url(#XMLID_7378_);}
	.st115{fill:url(#XMLID_7379_);}
	.st116{fill:url(#XMLID_7381_);}
	.st117{fill:url(#XMLID_7382_);}
	.st118{fill:url(#XMLID_7384_);}
	.st119{fill:url(#XMLID_7385_);}
	.st120{fill:url(#XMLID_7392_);}
	.st121{fill:url(#XMLID_7393_);}
	.st122{fill:url(#XMLID_7394_);}
	.st123{fill:url(#XMLID_7395_);}
	.st124{fill:url(#XMLID_7397_);}
	.st125{fill:url(#XMLID_7398_);}
	.st126{fill:url(#XMLID_7399_);}
	.st127{fill:#AED379;}
	.st128{fill:none;stroke:url(#XMLID_7576_);stroke-width:3;stroke-miterlimit:10;}
	.st129{fill:none;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st130{fill:url(#XMLID_7400_);}
	.st131{fill:url(#XMLID_7401_);}
	.st132{fill:url(#XMLID_7402_);}
	.st133{fill:url(#XMLID_7403_);}
	.st134{fill:url(#XMLID_7404_);}
	.st135{fill:url(#XMLID_7405_);}
	.st136{fill:url(#XMLID_7406_);}
	.st137{fill:url(#XMLID_7407_);}
	.st138{fill:url(#XMLID_7408_);}
	.st139{fill:url(#XMLID_7411_);}
	.st140{fill:url(#XMLID_7412_);}
	.st141{fill:url(#XMLID_7415_);}
	.st142{fill:url(#XMLID_7416_);}
	.st143{fill:url(#XMLID_7417_);}
	.st144{fill:url(#XMLID_7418_);}
	.st145{fill:url(#XMLID_7419_);}
	.st146{fill:url(#XMLID_7422_);}
	.st147{fill:url(#XMLID_7423_);}
	.st148{fill:url(#XMLID_7426_);}
	.st149{fill:url(#XMLID_7427_);}
	.st150{fill:url(#XMLID_7428_);}
	.st151{fill:url(#XMLID_7429_);}
	.st152{fill:url(#XMLID_7430_);}
	.st153{fill:url(#XMLID_7431_);}
	.st154{fill:url(#XMLID_7432_);}
	.st155{fill:url(#XMLID_7435_);}
	.st156{fill:url(#XMLID_7437_);}
	.st157{fill:url(#XMLID_7438_);}
	.st158{fill:url(#XMLID_7439_);}
	.st159{fill:url(#XMLID_7441_);}
	.st160{fill:url(#XMLID_7442_);}
	.st161{fill:url(#XMLID_7444_);}
	.st162{fill:url(#XMLID_7445_);}
	.st163{fill:url(#XMLID_7446_);}
	.st164{fill:url(#XMLID_7447_);}
	.st165{fill:url(#XMLID_7448_);}
	.st166{fill:url(#XMLID_7449_);}
	.st167{fill:url(#XMLID_7450_);}
	.st168{fill:url(#XMLID_7451_);}
	.st169{fill:url(#XMLID_7452_);}
	.st170{fill:url(#XMLID_7453_);}
	.st171{fill:url(#XMLID_7454_);}
	.st172{fill:url(#XMLID_7455_);}
	.st173{fill:url(#XMLID_7456_);}
	.st174{fill:url(#XMLID_7457_);}
	.st175{fill:url(#XMLID_7458_);}
	.st176{fill:url(#XMLID_7459_);}
	.st177{fill:url(#XMLID_7460_);}
	.st178{fill:url(#XMLID_7461_);}
	.st179{fill:url(#XMLID_7462_);}
	.st180{fill:url(#XMLID_7469_);}
	.st181{fill:url(#XMLID_7470_);}
	.st182{fill:url(#XMLID_7471_);}
	.st183{fill:url(#XMLID_7472_);}
	.st184{fill:url(#XMLID_7475_);}
	.st185{fill:url(#XMLID_7476_);}
	.st186{fill:url(#XMLID_7477_);}
	.st187{fill:url(#XMLID_7478_);}
	.st188{fill:url(#XMLID_7481_);}
	.st189{fill:url(#XMLID_7482_);}
	.st190{fill:url(#XMLID_7484_);}
	.st191{fill:url(#XMLID_7486_);}
	.st192{fill:url(#XMLID_7487_);}
	.st193{fill:url(#XMLID_7488_);}
	.st194{fill:url(#XMLID_7489_);}
	.st195{fill:url(#XMLID_7490_);}
	.st196{fill:url(#XMLID_7492_);}
	.st197{fill:url(#XMLID_7493_);}
	.st198{fill:url(#XMLID_7494_);}
	.st199{fill:url(#XMLID_7495_);}
	.st200{fill:url(#XMLID_7496_);}
	.st201{fill:url(#XMLID_7497_);}
	.st202{fill:url(#XMLID_7498_);}
	.st203{fill:url(#XMLID_7499_);}
	.st204{fill:none;stroke:url(#XMLID_7491_);stroke-width:6;stroke-miterlimit:10;}
	.st205{fill:#E0B192;}
	.st206{fill:#E0CEBD;}
	.st207{fill:#E0D6D1;}
	.st208{fill:url(#XMLID_7500_);}
	.st209{fill:url(#XMLID_7501_);}
	.st210{fill:url(#XMLID_7502_);}
	.st211{fill:url(#XMLID_7503_);}
	.st212{fill:url(#XMLID_7504_);}
	.st213{fill:url(#XMLID_7505_);}
	.st214{fill:url(#XMLID_7506_);}
	.st215{fill:url(#XMLID_7507_);}
	.st216{fill:url(#XMLID_7508_);}
	.st217{fill:url(#XMLID_7509_);}
	.st218{fill:#E0E2DE;}
	.st219{fill:url(#XMLID_7510_);}
	.st220{fill:url(#XMLID_7515_);}
	.st221{fill:url(#XMLID_7516_);}
	.st222{fill:url(#XMLID_7517_);}
	.st223{fill:url(#XMLID_7518_);}
	.st224{fill:url(#XMLID_7519_);}
	.st225{fill:url(#XMLID_7520_);}
	.st226{fill:url(#XMLID_7521_);}
	.st227{fill:url(#XMLID_7522_);}
	.st228{fill:url(#XMLID_7523_);}
	.st229{fill:url(#XMLID_7524_);}
	.st230{fill:url(#XMLID_7525_);}
	.st231{fill:url(#XMLID_7526_);}
	.st232{fill:url(#XMLID_7527_);}
	.st233{fill:url(#XMLID_7528_);}
	.st234{fill:url(#XMLID_7529_);}
	.st235{fill:url(#XMLID_7530_);}
	.st236{fill:url(#XMLID_7531_);}
	.st237{fill:url(#XMLID_7532_);}
	.st238{fill:url(#XMLID_7533_);}
	.st239{fill:url(#XMLID_7534_);}
	.st240{fill:url(#XMLID_7535_);}
	.st241{fill:url(#XMLID_7536_);}
	.st242{fill:url(#XMLID_7537_);}
	.st243{fill:url(#XMLID_7538_);}
	.st244{fill:url(#XMLID_7539_);}
	.st245{fill:url(#XMLID_7540_);}
	.st246{fill:url(#XMLID_7541_);}
	.st247{fill:url(#XMLID_7542_);}
	.st248{fill:url(#XMLID_7543_);}
	.st249{fill:url(#XMLID_7544_);}
	.st250{fill:url(#XMLID_7545_);}
	.st251{fill:url(#XMLID_7547_);}
	.st252{fill:url(#XMLID_7549_);}
	.st253{fill:url(#XMLID_7550_);}
	.st254{fill:url(#XMLID_7551_);}
	.st255{fill:url(#XMLID_7554_);}
	.st256{fill:url(#XMLID_7557_);}
	.st257{fill:url(#XMLID_7558_);}
	.st258{fill:url(#XMLID_7559_);}
	.st259{fill:url(#XMLID_7561_);}
	.st260{fill:url(#XMLID_7564_);}
	.st261{fill:url(#XMLID_7565_);}
	.st262{fill:url(#XMLID_7566_);}
	.st263{fill:url(#XMLID_7567_);}
	.st264{fill:url(#XMLID_7568_);}
	.st265{fill:url(#XMLID_7571_);}
	.st266{fill:url(#XMLID_7572_);}
	.st267{fill:url(#XMLID_7575_);}
	.st268{fill:url(#XMLID_7578_);}
	.st269{fill:url(#XMLID_7579_);}
	.st270{fill:url(#XMLID_7580_);}
	.st271{fill:url(#XMLID_7581_);}
	.st272{fill:url(#XMLID_7583_);}
	.st273{fill:url(#XMLID_7584_);}
	.st274{fill:url(#XMLID_7585_);}
	.st275{fill:url(#XMLID_7586_);}
	.st276{fill:url(#XMLID_7587_);}
	.st277{fill:url(#XMLID_7588_);}
	.st278{fill:url(#XMLID_7589_);}
	.st279{fill:url(#XMLID_7592_);}
	.st280{fill:url(#XMLID_7593_);}
	.st281{fill:url(#XMLID_7596_);}
	.st282{fill:url(#XMLID_7597_);}
	.st283{fill:url(#XMLID_7598_);}
	.st284{fill:url(#XMLID_7599_);}
	.st285{fill:#132C33;}
	.st286{fill:url(#XMLID_7600_);}
	.st287{fill:url(#XMLID_7601_);}
	.st288{fill:url(#XMLID_7602_);}
	.st289{fill:url(#XMLID_7603_);}
	.st290{fill:url(#XMLID_7604_);}
	.st291{fill:#E1E1E1;}
	.st292{clip-path:url(#XMLID_6652_);}
	.st293{fill:#E24471;}
	.st294{fill:#144191;}
	.st295{fill:#E2E2E2;}
	.st296{fill:none;stroke:#FF7676;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}
	.st297{fill:none;stroke:url(#XMLID_4361_);stroke-width:6;stroke-miterlimit:10;}
	.st298{fill:none;stroke:url(#XMLID_4365_);stroke-width:6;stroke-miterlimit:10;}
	.st299{clip-path:url(#XMLID_396_);}
	.st300{fill:none;stroke:url(#XMLID_7375_);stroke-width:3;stroke-miterlimit:10;}
	.st301{fill:none;stroke:#042AB2;stroke-width:5;stroke-miterlimit:10;}
	.st302{fill:none;stroke:url(#XMLID_5275_);stroke-width:3;stroke-miterlimit:10;}
	.st303{fill:none;stroke:#1D1D1B;stroke-width:0.5;stroke-miterlimit:10;}
	.st304{fill:#4A7B8E;}
	.st305{clip-path:url(#XMLID_465_);}
	.st306{fill:#E50A0A;}
	.st307{fill:#E51B72;}
	.st308{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st309{fill:#E5E1DC;}
	.st310{fill:none;stroke:url(#XMLID_7307_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st311{fill:none;stroke:url(#XMLID_4575_);stroke-width:6;stroke-miterlimit:10;}
	.st312{fill:#191A1C;}
	.st313{fill:none;stroke:#F9385D;stroke-width:3;stroke-miterlimit:10;}
	.st314{opacity:0.39;fill:#042AB2;}
	.st315{fill:#4D8E02;}
	.st316{fill:none;stroke:url(#XMLID_7465_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st317{fill:#E866FF;}
	.st318{fill:url(#XMLID_4266_);}
	.st319{fill:#E8B897;}
	.st320{fill:url(#XMLID_4267_);}
	.st321{fill:url(#XMLID_4280_);}
	.st322{fill:#E8E8DA;}
	.st323{fill:#E8E8E8;}
	.st324{fill:none;stroke:url(#XMLID_4611_);stroke-width:6;stroke-miterlimit:10;}
	.st325{fill:url(#XMLID_4304_);}
	.st326{fill:url(#XMLID_4307_);}
	.st327{fill:url(#XMLID_4315_);}
	.st328{fill:url(#XMLID_4355_);}
	.st329{fill:url(#XMLID_4357_);}
	.st330{fill:url(#XMLID_4358_);}
	.st331{fill:url(#XMLID_4362_);}
	.st332{fill:url(#XMLID_4364_);}
	.st333{fill:url(#XMLID_4368_);}
	.st334{fill:url(#XMLID_4371_);}
	.st335{fill:#FFFFFF;stroke:url(#XMLID_7466_);stroke-width:3;stroke-miterlimit:10;}
	.st336{fill:none;stroke:url(#XMLID_4614_);stroke-width:6;stroke-miterlimit:10;}
	.st337{fill:#FFFFFF;stroke:url(#XMLID_7467_);stroke-width:3;stroke-miterlimit:10;}
	.st338{fill:#4F4D4F;}
	.st339{fill:#4F514C;}
	.st340{fill:none;stroke:url(#XMLID_4615_);stroke-width:6;stroke-miterlimit:10;}
	.st341{fill:url(#XMLID_4432_);}
	.st342{fill:url(#XMLID_4440_);}
	.st343{fill:none;stroke:#96BCB5;stroke-miterlimit:10;}
	.st344{fill:none;stroke:url(#XMLID_4619_);stroke-width:6;stroke-miterlimit:10;}
	.st345{fill:none;stroke:url(#XMLID_7380_);stroke-width:3;stroke-miterlimit:10;}
	.st346{fill:#B0CAD1;}
	.st347{opacity:0.37;fill:url(#XMLID_4690_);}
	.st348{opacity:0.37;fill:url(#XMLID_4691_);}
	.st349{opacity:0.37;fill:url(#XMLID_4692_);}
	.st350{fill:#B0D882;}
	.st351{fill:#B0FFFF;}
	.st352{fill:url(#XMLID_4585_);}
	.st353{fill:url(#XMLID_4590_);}
	.st354{fill:url(#XMLID_4592_);}
	.st355{fill:url(#XMLID_4594_);}
	.st356{fill:url(#XMLID_4597_);}
	.st357{fill:none;stroke:url(#XMLID_7383_);stroke-width:3;stroke-miterlimit:10;}
	.st358{fill:none;stroke:url(#XMLID_4376_);stroke-width:6;stroke-miterlimit:10;}
	.st359{fill:url(#XMLID_4600_);}
	.st360{fill:url(#XMLID_4601_);}
	.st361{fill:url(#XMLID_4602_);}
	.st362{fill:url(#XMLID_4603_);}
	.st363{fill:url(#XMLID_4604_);}
	.st364{fill:url(#XMLID_4606_);}
	.st365{fill:url(#XMLID_4607_);}
	.st366{fill:url(#XMLID_4608_);}
	.st367{fill:url(#XMLID_4609_);}
	.st368{fill:url(#XMLID_4610_);}
	.st369{fill:url(#XMLID_4613_);}
	.st370{fill:url(#XMLID_4616_);}
	.st371{fill:url(#XMLID_4617_);}
	.st372{fill:url(#XMLID_4620_);}
	.st373{fill:url(#XMLID_4621_);}
	.st374{fill:url(#XMLID_4626_);}
	.st375{fill:url(#XMLID_4627_);}
	.st376{fill:url(#XMLID_4629_);}
	.st377{fill:url(#XMLID_4630_);}
	.st378{fill:url(#XMLID_4632_);}
	.st379{fill:url(#XMLID_4633_);}
	.st380{fill:url(#XMLID_4634_);}
	.st381{fill:url(#XMLID_4648_);}
	.st382{fill:url(#XMLID_4649_);}
	.st383{fill:url(#XMLID_4650_);}
	.st384{fill:url(#XMLID_4653_);}
	.st385{fill:url(#XMLID_4658_);}
	.st386{fill:url(#XMLID_4666_);}
	.st387{fill:url(#XMLID_4667_);}
	.st388{fill:url(#XMLID_4669_);}
	.st389{fill:url(#XMLID_4670_);}
	.st390{fill:url(#XMLID_4671_);}
	.st391{fill:url(#XMLID_4672_);}
	.st392{fill:url(#XMLID_4673_);}
	.st393{fill:url(#XMLID_4684_);}
	.st394{fill:url(#XMLID_4685_);}
	.st395{fill:url(#XMLID_4689_);}
	.st396{fill:none;stroke:url(#XMLID_7386_);stroke-width:3;stroke-miterlimit:10;}
	.st397{fill:none;stroke:url(#XMLID_7546_);stroke-width:6;stroke-miterlimit:10;}
	.st398{fill:none;stroke:#E2E2E2;stroke-miterlimit:10;}
	.st399{fill:none;stroke:url(#XMLID_7548_);stroke-width:6;stroke-miterlimit:10;}
	.st400{fill:url(#XMLID_4701_);}
	.st401{fill:url(#XMLID_4702_);}
	.st402{fill:url(#XMLID_4703_);}
	.st403{fill:url(#XMLID_4704_);}
	.st404{fill:url(#XMLID_4705_);}
	.st405{fill:url(#XMLID_4708_);}
	.st406{fill:url(#XMLID_4709_);}
	.st407{fill:url(#XMLID_4710_);}
	.st408{fill:url(#XMLID_4711_);}
	.st409{fill:url(#XMLID_4712_);}
	.st410{fill:url(#XMLID_4714_);}
	.st411{fill:url(#XMLID_4718_);}
	.st412{fill:url(#XMLID_4732_);}
	.st413{fill:url(#XMLID_4733_);}
	.st414{fill:url(#XMLID_4734_);}
	.st415{fill:url(#XMLID_4735_);}
	.st416{fill:url(#XMLID_4736_);}
	.st417{fill:url(#XMLID_4737_);}
	.st418{fill:url(#XMLID_4738_);}
	.st419{fill:url(#XMLID_4739_);}
	.st420{fill:url(#XMLID_4742_);}
	.st421{fill:url(#XMLID_4744_);}
	.st422{fill:url(#XMLID_4745_);}
	.st423{fill:url(#XMLID_4747_);}
	.st424{fill:url(#XMLID_4749_);}
	.st425{fill:url(#XMLID_4750_);}
	.st426{fill:url(#XMLID_4751_);}
	.st427{fill:url(#XMLID_4775_);}
	.st428{fill:url(#XMLID_4776_);}
	.st429{fill:url(#XMLID_4777_);}
	.st430{fill:url(#XMLID_4778_);}
	.st431{fill:url(#XMLID_4779_);}
	.st432{fill:url(#XMLID_4782_);}
	.st433{fill:url(#XMLID_4792_);}
	.st434{fill:#83FFE7;}
	.st435{fill:#FFFFFF;stroke:#444444;stroke-miterlimit:10;}
	.st436{fill:#FFFFFF;stroke:url(#XMLID_6164_);stroke-width:0.25;stroke-miterlimit:10;}
	.st437{fill:#848484;}
	.st438{fill:url(#XMLID_4810_);}
	.st439{fill:url(#XMLID_4816_);}
	.st440{fill:url(#XMLID_4818_);}
	.st441{fill:url(#XMLID_4819_);}
	.st442{fill:url(#XMLID_4821_);}
	.st443{fill:url(#XMLID_4837_);}
	.st444{fill:url(#XMLID_4838_);}
	.st445{fill:#B4754D;}
	.st446{fill:#B4B4B4;}
	.st447{fill:url(#XMLID_4909_);}
	.st448{fill:url(#XMLID_4923_);}
	.st449{fill:none;stroke:url(#XMLID_7594_);stroke-width:3;stroke-miterlimit:10;}
	.st450{fill:url(#XMLID_4951_);}
	.st451{fill:url(#XMLID_4952_);}
	.st452{fill:url(#XMLID_4953_);}
	.st453{fill:url(#XMLID_4954_);}
	.st454{fill:url(#XMLID_4955_);}
	.st455{fill:url(#XMLID_4956_);}
	.st456{fill:url(#XMLID_4957_);}
	.st457{fill:none;stroke:#1E1E1E;stroke-miterlimit:10;}
	.st458{fill:none;stroke:url(#XMLID_6532_);stroke-width:2;stroke-miterlimit:10;}
	.st459{fill:#FFFFFF;stroke:url(#XMLID_6174_);stroke-width:0.25;stroke-miterlimit:10;}
	.st460{fill:none;stroke:url(#XMLID_6533_);stroke-width:2;stroke-miterlimit:10;}
	.st461{fill:#B5AC9C;}
	.st462{fill:#B5B5B5;}
	.st463{fill:none;stroke:url(#XMLID_5273_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st464{fill:url(#XMLID_6551_);stroke:#444444;stroke-miterlimit:10;}
	.st465{fill:url(#XMLID_6554_);stroke:#444444;stroke-miterlimit:10;}
	.st466{fill:#FFFFFF;stroke:url(#XMLID_6168_);stroke-width:0.25;stroke-miterlimit:10;}
	.st467{fill:none;stroke:url(#XMLID_6538_);stroke-width:2;stroke-miterlimit:10;}
	.st468{fill:url(#XMLID_6555_);stroke:#444444;stroke-miterlimit:10;}
	.st469{fill:#EAEAEA;}
	.st470{fill:url(#XMLID_4950_);stroke:#383838;stroke-miterlimit:10;}
	.st471{fill:#B7B7B7;}
	.st472{fill:#1D1D1B;}
	.st473{fill:#898989;}
	.st474{fill:#1E1E1E;}
	.st475{fill:none;stroke:url(#XMLID_7391_);stroke-width:3;stroke-miterlimit:10;}
	.st476{fill:none;stroke:url(#XMLID_7511_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st477{fill:#FFFFFF;stroke:url(#XMLID_6212_);stroke-width:0.25;stroke-miterlimit:10;}
	.st478{fill:#EDEDED;}
	.st479{fill:#505154;}
	.st480{fill:#513B1E;}
	.st481{fill:#515151;}
	.st482{fill:#FFFFFF;stroke:url(#XMLID_6206_);stroke-width:0.25;stroke-miterlimit:10;}
	.st483{fill:#EF5A24;}
	.st484{fill:url(#XMLID_7325_);stroke:#232323;stroke-miterlimit:10;}
	.st485{fill:#EFEFEF;}
	.st486{fill:none;stroke:url(#XMLID_7433_);stroke-width:3;stroke-miterlimit:10;}
	.st487{fill:#FFFFFF;stroke:url(#XMLID_6216_);stroke-width:0.25;stroke-miterlimit:10;}
	.st488{fill:url(#XMLID_7085_);stroke:#232323;stroke-miterlimit:10;}
	.st489{fill:none;stroke:url(#XMLID_6542_);stroke-width:2;stroke-miterlimit:10;}
	.st490{fill:#544733;}
	.st491{fill:#545454;}
	.st492{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.st493{fill:none;stroke:url(#XMLID_7053_);stroke-width:4;stroke-miterlimit:10;}
	.st494{fill:#555555;}
	.st495{fill:#56361A;}
	.st496{fill:#564A3D;}
	.st497{fill:#FFFFFF;stroke:url(#XMLID_7376_);stroke-width:5;stroke-miterlimit:10;}
	.st498{fill:none;stroke:url(#XMLID_7205_);stroke-width:2;stroke-miterlimit:10;}
	.st499{fill:#BAC8D1;}
	.st500{fill:#BB8062;}
	.st501{fill:none;stroke:#28F7D1;stroke-width:3;stroke-miterlimit:10;}
	.st502{clip-path:url(#XMLID_7208_);}
	.st503{fill:url(#XMLID_4781_);stroke:#232323;stroke-miterlimit:10;}
	.st504{clip-path:url(#XMLID_7264_);}
	.st505{fill:#8E734F;}
	.st506{fill:none;stroke:#F9385D;stroke-width:2;stroke-miterlimit:10;}
	.st507{clip-path:url(#XMLID_7314_);}
	.st508{clip-path:url(#XMLID_7390_);}
	.st509{clip-path:url(#XMLID_7396_);}
	.st510{fill:#C7EE95;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st511{fill:none;stroke:url(#XMLID_4437_);stroke-width:6;stroke-miterlimit:10;}
	.st512{fill:#8F9D9E;}
	.st513{clip-path:url(#XMLID_7414_);}
	.st514{fill:url(#XMLID_7074_);stroke:#383838;stroke-miterlimit:10;}
	.st515{fill:#FFFFFF;stroke:url(#XMLID_6099_);stroke-width:0.25;stroke-miterlimit:10;}
	.st516{clip-path:url(#XMLID_7468_);}
	.st517{clip-path:url(#XMLID_7474_);}
	.st518{fill:none;stroke:url(#XMLID_7305_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st519{fill:#BFBFBF;}
	.st520{fill:none;stroke:url(#XMLID_4481_);stroke-width:3;stroke-miterlimit:10;}
	.st521{clip-path:url(#XMLID_7563_);}
	.st522{clip-path:url(#XMLID_7591_);}
	.st523{fill:none;stroke:url(#XMLID_7463_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st524{opacity:0.58;fill:#FFFFFF;}
	.st525{fill:#2368D9;}
	.st526{fill:#23CAD9;}
	.st527{fill:#F2F2F2;}
	.st528{fill:url(#XMLID_4809_);stroke:#383838;stroke-miterlimit:10;}
	.st529{fill:#F3F3E5;}
	.st530{fill:#F4C4A4;}
	.st531{fill:#FFFFFF;stroke:url(#XMLID_6153_);stroke-width:0.25;stroke-miterlimit:10;}
	.st532{opacity:0.4;fill:#1D1D1B;}
	.st533{fill:url(#XMLID_7323_);stroke:#383838;stroke-miterlimit:10;}
	.st534{fill:none;stroke:url(#XMLID_4441_);stroke-width:6;stroke-miterlimit:10;}
	.st535{fill:url(#XMLID_5010_);}
	.st536{fill:url(#XMLID_5011_);}
	.st537{fill:url(#XMLID_5012_);}
	.st538{fill:url(#XMLID_5013_);}
	.st539{fill:url(#XMLID_5014_);}
	.st540{fill:url(#XMLID_5018_);}
	.st541{fill:url(#XMLID_5019_);}
	.st542{fill:url(#XMLID_5055_);}
	.st543{fill:url(#XMLID_5057_);}
	.st544{fill:url(#XMLID_5058_);}
	.st545{fill:url(#XMLID_5059_);}
	.st546{fill:#282828;}
	.st547{fill:url(#XMLID_5060_);}
	.st548{fill:url(#XMLID_5061_);}
	.st549{fill:url(#XMLID_5062_);}
	.st550{fill:none;stroke:url(#XMLID_4445_);stroke-width:6;stroke-miterlimit:10;}
	.st551{fill:none;stroke:url(#XMLID_7313_);stroke-width:4;stroke-miterlimit:10;}
	.st552{fill:#28F7D1;}
	.st553{fill:url(#XMLID_7329_);stroke:#383838;stroke-miterlimit:10;}
	.st554{fill:url(#XMLID_5105_);}
	.st555{fill:url(#XMLID_5107_);}
	.st556{fill:url(#XMLID_5108_);}
	.st557{fill:#F7B033;}
	.st558{fill:url(#XMLID_5181_);}
	.st559{fill:#F7F7F7;}
	.st560{fill:#F7F8F9;}
	.st561{clip-path:url(#XMLID_4278_);}
	.st562{fill:url(#XMLID_5267_);}
	.st563{fill:url(#XMLID_5276_);}
	.st564{fill:url(#XMLID_5278_);}
	.st565{fill:url(#XMLID_5281_);}
	.st566{fill:url(#XMLID_5282_);}
	.st567{fill:url(#XMLID_5285_);}
	.st568{fill:url(#XMLID_5286_);}
	.st569{fill:url(#XMLID_5288_);}
	.st570{fill:url(#XMLID_5289_);}
	.st571{fill:#FFFFFF;stroke:url(#XMLID_6157_);stroke-width:0.25;stroke-miterlimit:10;}
	.st572{fill:#5E5E5E;}
	.st573{fill:#F9385D;}
	.st574{fill:url(#XMLID_6416_);stroke:#444444;stroke-miterlimit:10;}
	.st575{fill:url(#XMLID_5300_);}
	.st576{fill:url(#XMLID_5301_);}
	.st577{fill:url(#XMLID_5304_);}
	.st578{fill:url(#XMLID_5305_);}
	.st579{fill:url(#XMLID_5313_);}
	.st580{fill:url(#XMLID_5317_);}
	.st581{fill:url(#XMLID_5318_);}
	.st582{fill:url(#XMLID_6417_);stroke:#444444;stroke-miterlimit:10;}
	.st583{fill:url(#XMLID_5338_);}
	.st584{fill:url(#XMLID_5343_);}
	.st585{fill:url(#XMLID_5345_);}
	.st586{fill:url(#XMLID_5346_);}
	.st587{fill:url(#XMLID_5347_);}
	.st588{fill:url(#XMLID_5348_);}
	.st589{fill:url(#XMLID_5349_);}
	.st590{fill:url(#XMLID_5350_);}
	.st591{fill:url(#XMLID_5351_);}
	.st592{fill:url(#XMLID_5352_);}
	.st593{fill:url(#XMLID_5353_);}
	.st594{fill:url(#XMLID_5354_);}
	.st595{fill:none;stroke:url(#XMLID_5271_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st596{fill:url(#XMLID_5389_);}
	.st597{fill:#FFFFFF;stroke:url(#XMLID_6173_);stroke-width:0.25;stroke-miterlimit:10;}
	.st598{fill:url(#XMLID_5392_);}
	.st599{fill:url(#XMLID_6418_);stroke:#444444;stroke-miterlimit:10;}
	.st600{fill:url(#XMLID_6419_);stroke:#444444;stroke-miterlimit:10;}
	.st601{opacity:0.35;fill:#9FEDFF;}
	.st602{clip-path:url(#XMLID_4439_);}
	.st603{clip-path:url(#XMLID_4442_);}
	.st604{fill:url(#XMLID_5432_);}
	.st605{clip-path:url(#XMLID_4477_);}
	.st606{fill:url(#XMLID_5470_);}
	.st607{fill:url(#XMLID_5479_);}
	.st608{fill:url(#XMLID_5483_);}
	.st609{fill:url(#XMLID_5485_);}
	.st610{fill:url(#XMLID_5486_);}
	.st611{fill:url(#XMLID_5488_);}
	.st612{fill:url(#XMLID_5489_);}
	.st613{fill:url(#XMLID_5490_);}
	.st614{fill:url(#XMLID_5491_);}
	.st615{fill:url(#XMLID_5492_);}
	.st616{fill:url(#XMLID_5493_);}
	.st617{fill:url(#XMLID_5495_);}
	.st618{fill:url(#XMLID_5496_);}
	.st619{fill:none;stroke:url(#XMLID_5279_);stroke-width:6;stroke-miterlimit:10;}
	.st620{fill:none;stroke:url(#XMLID_7552_);stroke-width:5;stroke-miterlimit:10;}
	.st621{fill:#C07E61;}
	.st622{fill:#918E91;}
	.st623{fill:#C0C1BB;}
	.st624{fill:url(#XMLID_5513_);}
	.st625{fill:url(#XMLID_5514_);}
	.st626{clip-path:url(#XMLID_4568_);}
	.st627{fill:url(#XMLID_5556_);}
	.st628{fill:#C12F52;}
	.st629{fill:#929292;}
	.st630{fill:#C1A880;}
	.st631{fill:#C1C1C1;}
	.st632{fill:url(#XMLID_5639_);}
	.st633{clip-path:url(#XMLID_4675_);}
	.st634{clip-path:url(#XMLID_4693_);}
	.st635{clip-path:url(#XMLID_4695_);}
	.st636{fill:url(#XMLID_5675_);}
	.st637{fill:url(#SVGID_1_);}
	.st638{fill:#FFFFFF;stroke:url(#XMLID_6177_);stroke-width:0.25;stroke-miterlimit:10;}
	.st639{fill:#93837A;}
	.st640{fill:#9397A5;}
	.st641{fill:#939FA3;}
	.st642{fill:url(#XMLID_5702_);}
	.st643{fill:url(#XMLID_5713_);}
	.st644{fill:url(#XMLID_5723_);}
	.st645{fill:url(#XMLID_5724_);}
	.st646{fill:url(#XMLID_5725_);}
	.st647{fill:url(#XMLID_5727_);}
	.st648{fill:url(#XMLID_5728_);}
	.st649{fill:url(#XMLID_5729_);}
	.st650{fill:url(#XMLID_5730_);}
	.st651{fill:url(#XMLID_5733_);}
	.st652{fill:url(#XMLID_5734_);}
	.st653{fill:url(#XMLID_5739_);}
	.st654{fill:url(#XMLID_5742_);}
	.st655{fill:url(#XMLID_5745_);}
	.st656{fill:url(#XMLID_5747_);}
	.st657{clip-path:url(#XMLID_4772_);}
	.st658{fill:url(#XMLID_5751_);}
	.st659{fill:#93ADAD;}
	.st660{fill:url(#XMLID_7332_);stroke:#383838;stroke-miterlimit:10;}
	.st661{fill:#943B8A;}
	.st662{clip-path:url(#XMLID_4817_);}
	.st663{fill:#C3CDDD;}
	.st664{fill:url(#XMLID_4780_);stroke:#383838;stroke-miterlimit:10;}
	.st665{fill:url(#XMLID_5838_);}
	.st666{fill:url(#XMLID_5841_);}
	.st667{fill:#C7EE95;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}
	.st668{fill:url(#XMLID_5863_);}
	.st669{fill:url(#XMLID_5915_);}
	.st670{fill:url(#XMLID_5916_);}
	.st671{fill:url(#XMLID_5917_);}
	.st672{fill:url(#XMLID_5918_);}
	.st673{fill:url(#XMLID_5919_);}
	.st674{fill:url(#XMLID_5924_);}
	.st675{fill:url(#XMLID_5925_);}
	.st676{fill:url(#XMLID_5926_);}
	.st677{fill:url(#XMLID_5927_);}
	.st678{fill:url(#XMLID_5931_);}
	.st679{fill:url(#XMLID_5933_);}
	.st680{fill:url(#XMLID_5934_);}
	.st681{fill:url(#XMLID_5935_);}
	.st682{fill:url(#XMLID_5936_);}
	.st683{fill:url(#XMLID_5943_);}
	.st684{fill:#95BAC6;}
	.st685{fill:none;stroke:url(#XMLID_7308_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st686{fill:#C54EB9;}
	.st687{fill:url(#XMLID_6420_);stroke:#444444;stroke-miterlimit:10;}
	.st688{fill:none;stroke:url(#XMLID_4773_);stroke-width:4;stroke-miterlimit:10;}
	.st689{fill:#2B2B2B;}
	.st690{fill:none;stroke:url(#XMLID_4774_);stroke-width:4;stroke-miterlimit:10;}
	.st691{fill:url(#XMLID_6424_);stroke:#444444;stroke-miterlimit:10;}
	.st692{font-family:'FontBase-Regular';}
	.st693{fill:none;stroke:url(#XMLID_4660_);stroke-width:6;stroke-miterlimit:10;}
	.st694{fill:none;stroke:url(#XMLID_7056_);stroke-width:3;stroke-miterlimit:10;}
	.st695{fill:#FFFFFF;stroke:url(#XMLID_6215_);stroke-width:0.25;stroke-miterlimit:10;}
	.st696{fill:#FFFFFF;stroke:#B7B7B7;stroke-width:0.75;stroke-miterlimit:10;}
	.st697{fill:#C7EE95;}
	.st698{fill:#C7F2E9;}
	.st699{fill:#2D2D2D;}
	.st700{fill:#FBE429;}
	.st701{fill:none;stroke:url(#XMLID_4668_);stroke-width:6;stroke-miterlimit:10;}
	.st702{fill:none;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st703{fill:#FFFFFF;stroke:url(#XMLID_6209_);stroke-width:0.25;stroke-miterlimit:10;}
	.st704{fill:url(#XMLID_7134_);stroke:#383838;stroke-miterlimit:10;}
	.st705{fill:#998365;}
	.st706{fill:#99845F;}
	.st707{fill:none;stroke:url(#XMLID_4813_);stroke-width:4;stroke-miterlimit:10;}
	.st708{fill:none;stroke:url(#XMLID_7263_);stroke-width:3;stroke-miterlimit:10;}
	.st709{fill:#FFFFFF;stroke:url(#XMLID_7553_);stroke-width:3;stroke-miterlimit:10;}
	.st710{fill:none;stroke:#28F7D1;stroke-width:2;stroke-miterlimit:10;}
	.st711{fill:none;stroke:url(#XMLID_4958_);stroke-width:3;stroke-miterlimit:10;}
	.st712{fill:#C9C9C9;}
	.st713{fill:none;stroke:url(#XMLID_4959_);stroke-width:3;stroke-miterlimit:10;}
	.st714{fill:#FFFFFF;stroke:url(#XMLID_7556_);stroke-width:3;stroke-miterlimit:10;}
	.st715{fill:#605147;}
	.st716{fill:#605C60;}
	.st717{fill:none;stroke:url(#XMLID_5268_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st718{fill:none;stroke:url(#XMLID_4274_);stroke-width:2;stroke-miterlimit:10;}
	.st719{fill:#FF3BCC;}
	.st720{fill:#FF7676;}
	.st721{fill:#FF88A4;}
	.st722{fill:#FF9852;}
	.st723{fill:#FFAF50;}
	.st724{fill:#FFB236;}
	.st725{fill:#FFBC73;}
	.st726{fill:#FFC555;}
	.st727{fill:#FFD366;}
	.st728{fill:#FFD773;}
	.st729{fill:#FFD77E;}
	.st730{fill:#FFDB92;}
	.st731{fill:#FFE2CA;}
	.st732{fill:#FFE52C;}
	.st733{fill:#FFE825;}
	.st734{fill:#FFEFAB;}
	.st735{fill:#FFFF00;}
	.st736{fill:#FFFFFF;}
	.st737{fill:none;stroke:url(#XMLID_7473_);stroke-width:3;stroke-miterlimit:10;}
	.st738{fill:url(#XMLID_4793_);stroke:#383838;stroke-miterlimit:10;}
	.st739{opacity:0.27;fill:#605C60;}
	.st740{fill:url(#XMLID_7570_);stroke:#232323;stroke-miterlimit:10;}
	.st741{fill:none;stroke:url(#XMLID_4312_);stroke-width:2;stroke-miterlimit:10;}
	.st742{fill:#FFFFFF;stroke:url(#XMLID_6245_);stroke-width:0.25;stroke-miterlimit:10;}
	.st743{fill:none;stroke:url(#XMLID_7063_);stroke-width:3;stroke-miterlimit:10;}
	.st744{fill:none;stroke:url(#XMLID_7064_);stroke-width:3;stroke-miterlimit:10;}
	.st745{fill:none;}
	.st746{fill:#FFFFFF;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st747{fill:#FFFFFF;stroke:url(#XMLID_6098_);stroke-width:0.25;stroke-miterlimit:10;}
	.st748{fill:none;stroke:url(#XMLID_4676_);stroke-width:6;stroke-miterlimit:10;}
	.st749{fill:#666461;}
	.st750{fill:#666666;}
	.st751{fill:url(#XMLID_7143_);stroke:#383838;stroke-miterlimit:10;}
	.st752{fill:#9A5F3E;}
	.st753{fill:none;stroke:url(#XMLID_4678_);stroke-width:6;stroke-miterlimit:10;}
	.st754{fill:url(#XMLID_6640_);stroke:#444444;stroke-miterlimit:10;}
	.st755{fill:#FFFFFF;stroke:url(#XMLID_7560_);stroke-width:3;stroke-miterlimit:10;}
	.st756{fill:#9AF2F7;}
	.st757{fill:url(#XMLID_6641_);stroke:#444444;stroke-miterlimit:10;}
	.st758{fill:none;stroke:url(#XMLID_7272_);stroke-width:3;stroke-miterlimit:10;}
	.st759{fill:none;stroke:url(#XMLID_7273_);stroke-width:3;stroke-miterlimit:10;}
	.st760{fill:#FFFFFF;stroke:url(#XMLID_7562_);stroke-width:3;stroke-miterlimit:10;}
	.st761{fill:#FFFFFF;stroke:url(#XMLID_6249_);stroke-width:0.25;stroke-miterlimit:10;}
	.st762{fill:#9B9B9B;}
	.st763{fill:#CACCC8;}
	.st764{fill:#9BC16B;}
	.st765{fill:none;stroke:url(#XMLID_4694_);stroke-width:2;stroke-miterlimit:10;}
	.st766{fill:none;stroke:url(#XMLID_7512_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st767{fill:url(#XMLID_6645_);stroke:#444444;stroke-miterlimit:10;}
	.st768{fill:#686868;}
	.st769{fill:#68696D;}
	.st770{fill:url(#XMLID_6646_);stroke:#444444;stroke-miterlimit:10;}
	.st771{fill:url(#XMLID_6647_);stroke:#444444;stroke-miterlimit:10;}
	.st772{fill:url(#XMLID_6648_);stroke:#444444;stroke-miterlimit:10;}
	.st773{fill:#9CA09D;}
	.st774{fill:url(#XMLID_6649_);stroke:#444444;stroke-miterlimit:10;}
	.st775{fill:none;stroke:url(#XMLID_7310_);stroke-width:3;stroke-miterlimit:10;}
	.st776{fill:#CCA885;}
	.st777{fill:none;stroke:url(#XMLID_5766_);stroke-width:2;stroke-miterlimit:10;}
	.st778{fill:#CCCCCC;}
	.st779{fill:#CCD8E2;}
	.st780{fill:#9E7F66;}
	.st781{fill:#303233;}
	.st782{fill:#303844;}
	.st783{fill:none;stroke:url(#XMLID_7345_);stroke-width:4;stroke-miterlimit:10;}
	.st784{fill:#CECECE;}
	.st785{fill:#9FF4F4;}
	.st786{fill:#FFFFFF;stroke:url(#XMLID_6162_);stroke-width:0.25;stroke-miterlimit:10;}
	.st787{fill:#32ADF0;}
	.st788{fill:#333333;}
	.st789{opacity:0.24;fill:#FFFFFF;}
	.st790{fill:#FFFFFF;stroke:#CCCCCC;stroke-miterlimit:10;}
	.st791{fill:url(#XMLID_7569_);stroke:#383838;stroke-miterlimit:10;}
	.st792{opacity:0.5;fill:#A1A1A1;}
	.st793{fill:#352B1B;}
	.st794{fill:none;stroke:#444444;stroke-miterlimit:10;}
	.st795{fill:#353535;}
	.st796{fill:#353638;}
	.st797{fill:#3574DC;}
	.st798{fill:#FFFFFF;stroke:url(#XMLID_7577_);stroke-width:3;stroke-miterlimit:10;}
	.st799{fill:url(#XMLID_4908_);stroke:#232323;stroke-miterlimit:10;}
	.st800{fill:#FFFFFF;stroke:url(#XMLID_6200_);stroke-width:0.25;stroke-miterlimit:10;}
	.st801{fill:#6B7284;}
	.st802{fill:none;stroke:url(#XMLID_5779_);stroke-width:2;stroke-miterlimit:10;}
	.st803{fill:url(#XMLID_6095_);}
	.st804{fill:url(#XMLID_6097_);}
	.st805{fill:none;stroke:url(#XMLID_4317_);stroke-width:6;stroke-miterlimit:10;}
	.st806{fill:url(#XMLID_5732_);stroke:#232323;stroke-miterlimit:10;}
	.st807{fill:none;stroke:url(#XMLID_5811_);stroke-width:2;stroke-miterlimit:10;}
	.st808{fill:none;stroke:url(#XMLID_5812_);stroke-width:2;stroke-miterlimit:10;}
	.st809{fill:none;stroke:url(#XMLID_7355_);stroke-width:4;stroke-miterlimit:10;}
	.st810{fill:url(#XMLID_6170_);}
	.st811{fill:url(#XMLID_6171_);}
	.st812{fill:url(#XMLID_6178_);}
	.st813{fill:#39466B;}
	.st814{fill:url(#XMLID_6188_);}
	.st815{fill:url(#XMLID_7421_);stroke:#232323;stroke-miterlimit:10;}
	.st816{fill:url(#XMLID_6189_);}
	.st817{fill:url(#XMLID_6191_);}
	.st818{fill:#397AC9;}
	.st819{fill:#6D6D6D;}
	.st820{fill:none;stroke:url(#XMLID_5842_);stroke-width:3;stroke-miterlimit:10;}
	.st821{fill:url(#XMLID_6238_);}
	.st822{fill:url(#XMLID_6241_);}
	.st823{fill:url(#XMLID_6254_);}
	.st824{fill:url(#XMLID_6255_);}
	.st825{fill:url(#XMLID_7573_);stroke:#383838;stroke-miterlimit:10;}
	.st826{fill:#FFFFFF;stroke:url(#XMLID_6204_);stroke-width:0.25;stroke-miterlimit:10;}
	.st827{fill:none;stroke:url(#XMLID_5845_);stroke-width:3;stroke-miterlimit:10;}
	.st828{fill:url(#XMLID_7574_);stroke:#383838;stroke-miterlimit:10;}
	.st829{fill:#001F77;}
	.st830{fill:#003449;}
	.st831{fill:#004263;}
	.st832{fill:#006384;}
	.st833{fill:#006937;}
	.st834{fill:#008FB6;}
	.st835{fill:#00B2CD;}
	.st836{fill:none;stroke:url(#XMLID_7464_);stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st837{fill:none;stroke:url(#XMLID_4812_);stroke-width:3;stroke-miterlimit:10;}
	.st838{fill:url(#XMLID_6413_);}
	.st839{fill:url(#XMLID_6421_);}
	.st840{fill:url(#XMLID_6422_);}
	.st841{fill:url(#XMLID_6423_);}
	.st842{fill:none;stroke:url(#XMLID_4369_);stroke-width:3;stroke-miterlimit:10;}
	.st843{fill:url(#XMLID_4856_);stroke:#383838;stroke-miterlimit:10;}
	.st844{fill:#FFFFFF;stroke:url(#XMLID_7410_);stroke-width:3;stroke-miterlimit:10;}
	.st845{fill:none;stroke:url(#XMLID_4698_);stroke-width:6;stroke-miterlimit:10;}
	.st846{fill:#020202;}
	.st847{fill:#D0D0D0;}
	.st848{fill:#FFFFFF;stroke:url(#XMLID_7413_);stroke-width:3;stroke-miterlimit:10;}
	.st849{fill:url(#XMLID_6521_);}
	.st850{fill:#FFFFFF;stroke:url(#XMLID_7582_);stroke-width:3;stroke-miterlimit:10;}
	.st851{fill:url(#XMLID_6544_);}
	.st852{fill:url(#XMLID_6550_);}
	.st853{fill:none;stroke:#2368D9;stroke-width:3;stroke-miterlimit:10;}
	.st854{opacity:0.3;fill:#1D1D1B;}
	.st855{fill:#D1D1D1;}
	.st856{fill:url(#XMLID_6642_);}
	.st857{fill:url(#XMLID_6643_);}
	.st858{fill:url(#XMLID_6644_);}
	.st859{fill:url(#XMLID_6650_);}
	.st860{fill:url(#XMLID_6662_);}
	.st861{fill:url(#XMLID_6666_);}
	.st862{fill:#FFFFFF;stroke:url(#XMLID_6208_);stroke-width:0.25;stroke-miterlimit:10;}
	.st863{fill:url(#XMLID_6667_);stroke:#444444;stroke-miterlimit:10;}
	.st864{fill:url(#XMLID_6668_);stroke:#444444;stroke-miterlimit:10;}
	.st865{fill:#D29472;}
	.st866{fill:#042AB2;}
	.st867{opacity:0.19;fill:#998365;}
	.st868{clip-path:url(#XMLID_5837_);}
	.st869{clip-path:url(#XMLID_5844_);}
	.st870{clip-path:url(#XMLID_5862_);}
	.st871{fill:#FFFFFF;stroke:url(#XMLID_6218_);stroke-width:0.25;stroke-miterlimit:10;}
	.st872{fill:none;stroke:url(#XMLID_7335_);stroke-width:3;stroke-miterlimit:10;}
	.st873{fill:none;stroke:#E50A0A;stroke-width:2;stroke-miterlimit:10;}
	.st874{fill:#3A2914;}
	.st875{fill:#3A3A3A;}
	.st876{fill:#3A4747;}
	.st877{fill:#FFFFFF;stroke:url(#XMLID_6250_);stroke-width:0.25;stroke-miterlimit:10;}
	.st878{fill:url(#XMLID_384_);}
	.st879{fill:url(#XMLID_387_);}
	.st880{fill:url(#XMLID_392_);}
	.st881{fill:url(#XMLID_397_);}
	.st882{fill:url(#XMLID_398_);}
	.st883{fill:#D6D6D6;}
	.st884{fill:url(#XMLID_400_);}
	.st885{fill:#3D3D3D;}
	.st886{fill:#FFFFFF;stroke:url(#XMLID_7590_);stroke-width:3;stroke-miterlimit:10;}
	.st887{fill:none;stroke:url(#XMLID_7409_);stroke-width:4;stroke-miterlimit:10;}
	.st888{fill:url(#XMLID_6504_);stroke:#444444;stroke-miterlimit:10;}
	.st889{fill:none;stroke:url(#XMLID_4740_);stroke-width:6;stroke-miterlimit:10;}
	.st890{fill:url(#XMLID_6505_);stroke:#444444;stroke-miterlimit:10;}
	.st891{fill:#FFFFFF;stroke:url(#XMLID_7595_);stroke-width:3;stroke-miterlimit:10;}
	.st892{fill:#707070;}
	.st893{fill:#A0A0A0;}
	.st894{fill:#727272;}
	.st895{fill:url(#XMLID_5731_);stroke:#383838;stroke-miterlimit:10;}
	.st896{fill:none;stroke:url(#XMLID_7347_);stroke-width:3;stroke-miterlimit:10;}
	.st897{fill:none;stroke:url(#XMLID_5832_);stroke-width:2;stroke-miterlimit:10;}
	.st898{fill:#A2A599;}
	.st899{fill:#A2A7AC;}
	.st900{fill:none;stroke:url(#XMLID_5833_);stroke-width:2;stroke-miterlimit:10;}
	.st901{fill:url(#XMLID_7420_);stroke:#383838;stroke-miterlimit:10;}
	.st902{fill:#A3A3A3;}
	.st903{fill:url(#XMLID_5737_);stroke:#383838;stroke-miterlimit:10;}
	.st904{fill:#FFFFFF;stroke:url(#XMLID_6151_);stroke-width:0.25;stroke-miterlimit:10;}
	.st905{fill:url(#XMLID_7424_);stroke:#383838;stroke-miterlimit:10;}
	.st906{fill:url(#XMLID_5738_);stroke:#383838;stroke-miterlimit:10;}
	.st907{fill:url(#XMLID_7425_);stroke:#383838;stroke-miterlimit:10;}
	.st908{fill:none;stroke:#28F7D1;stroke-miterlimit:10;}
	.st909{fill:#A4704C;}
	.st910{fill:#A4BCC1;}
	.st911{fill:#0A2D56;}
	.st912{fill:none;stroke:url(#XMLID_7555_);stroke-width:3;stroke-miterlimit:10;}
	.st913{fill:#A57B44;}
	.st914{fill:none;stroke:url(#XMLID_411_);stroke-width:2;stroke-miterlimit:10;}
	.st915{fill:#FFFFFF;stroke:url(#XMLID_6161_);stroke-width:0.25;stroke-miterlimit:10;}
	.st916{fill:#777777;}
	.st917{fill:#DA9571;}
	.st918{fill:#FFFFFF;stroke:url(#XMLID_7434_);stroke-width:3;stroke-miterlimit:10;}
	.st919{fill:url(#XMLID_6515_);stroke:#444444;stroke-miterlimit:10;}
	.st920{fill:#0C455B;}
	.st921{fill:#FFFFFF;stroke:url(#XMLID_7436_);stroke-width:3;stroke-miterlimit:10;}
	.st922{fill:#DB6812;}
	.st923{fill:#0D1F30;}
	.st924{fill:none;stroke:url(#XMLID_7479_);stroke-width:6;stroke-miterlimit:10;}
	.st925{fill:#A8947E;}
	.st926{fill:#A8A8A8;}
	.st927{fill:#79E0E0;}
	.st928{fill:#DCFFF8;}
	.st929{fill:#0F0F0F;}
	.st930{fill:none;stroke:url(#XMLID_7514_);stroke-width:6;stroke-miterlimit:10;}
	.st931{fill:#0F4B63;}
	.st932{fill:#DDDDDD;}
	.st933{fill:#DDE5ED;}
	.st934{fill:#404949;}
	.st935{fill:none;stroke:url(#XMLID_7357_);stroke-width:3;stroke-miterlimit:10;}
	.st936{fill:#FFFFFF;stroke:url(#XMLID_6159_);stroke-width:0.25;stroke-miterlimit:10;}
	.st937{fill:#DEFFAE;}
	.st938{fill:#DFDFDF;}
	.st939{font-size:20.0331;}
	.st940{fill:#424242;}
	.st941{opacity:0.51;fill:#FFFFFF;enable-background:new    ;}
	.st942{fill:#FFFFFF;stroke:url(#XMLID_7440_);stroke-width:3;stroke-miterlimit:10;}
	.st943{fill:none;stroke:url(#XMLID_7480_);stroke-width:6;stroke-miterlimit:10;}
	.st944{fill:#444444;}
	.st945{fill:#FFFFFF;stroke:url(#XMLID_7443_);stroke-width:3;stroke-miterlimit:10;}
	.st946{fill:none;stroke:url(#XMLID_7483_);stroke-width:6;stroke-miterlimit:10;}
	.st947{fill:none;stroke:url(#XMLID_7485_);stroke-width:6;stroke-miterlimit:10;}
   .oculto{
      display: none;
    }
    #img1,#img2,#img3,#img4,#img5,#img6,#img7,#img8{
       cursor: pointer;
    }
</style>